/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AssigmenDetailtWorksheetSet = {
  __typename?: 'AssigmenDetailtWorksheetSet';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssigmentDetailWorksheetSetVersion = {
  __typename?: 'AssigmentDetailWorksheetSetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet: AssigmenDetailtWorksheetSet;
};

export type AssigmentWorksheetSet = {
  __typename?: 'AssigmentWorksheetSet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssigmentWorksheetSetVersion = {
  __typename?: 'AssigmentWorksheetSetVersion';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<AssigmentWorksheetSet>;
};

export type Assignment = {
  __typename?: 'Assignment';
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<AssigmentWorksheetSetVersion>;
};

export type AssignmentDetail = {
  __typename?: 'AssignmentDetail';
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion: AssigmentDetailWorksheetSetVersion;
};

export type BookFilters = {
  OR?: InputMaybe<Array<BookFiltersOr>>;
  gaudiaLevelId?: InputMaybe<BookGaudiaLevelIdFilters>;
  id?: InputMaybe<BookIdFilters>;
  name?: InputMaybe<BookNameFilters>;
};

export type BookFiltersOr = {
  gaudiaLevelId?: InputMaybe<BookGaudiaLevelIdFilters>;
  id?: InputMaybe<BookIdFilters>;
  name?: InputMaybe<BookNameFilters>;
};

export type BookGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<BookGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookGaudiaLevelRelation = {
  __typename?: 'BookGaudiaLevelRelation';
  books: Array<BookGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<BookGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type BookGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type BookGaudiaLevelRelationBooksRelation = {
  __typename?: 'BookGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'BookGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookIdFilters = {
  OR?: InputMaybe<Array<BookIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookInsertInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type BookItem = {
  __typename?: 'BookItem';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookNameFilters = {
  OR?: InputMaybe<Array<BookNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookOrderBy = {
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type BookSelectItem = {
  __typename?: 'BookSelectItem';
  gaudiaLevel?: Maybe<BookGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<BookUnitsRelation>;
};


export type BookSelectItemGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type BookSelectItemUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type BookUnitsRelation = {
  __typename?: 'BookUnitsRelation';
  book?: Maybe<BookUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<BookUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<BookUnitsRelationSubunitsRelation>;
};


export type BookUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type BookUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type BookUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type BookUnitsRelationBookRelation = {
  __typename?: 'BookUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationEdukitaLevelRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationSubunitsRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<BookUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<BookUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type BookUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type BookUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type BookUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type BookUpdateInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomSessionWithStudents = {
  __typename?: 'ClassroomSessionWithStudents';
  session?: Maybe<Session>;
  students?: Maybe<Array<Maybe<Student>>>;
};

export type EdukitaLevelFilters = {
  OR?: InputMaybe<Array<EdukitaLevelFiltersOr>>;
  gaudiaLevelId?: InputMaybe<EdukitaLevelGaudiaLevelIdFilters>;
  id?: InputMaybe<EdukitaLevelIdFilters>;
  name?: InputMaybe<EdukitaLevelNameFilters>;
};

export type EdukitaLevelFiltersOr = {
  gaudiaLevelId?: InputMaybe<EdukitaLevelGaudiaLevelIdFilters>;
  id?: InputMaybe<EdukitaLevelIdFilters>;
  name?: InputMaybe<EdukitaLevelNameFilters>;
};

export type EdukitaLevelGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<EdukitaLevelGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelGaudiaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelation';
  books: Array<EdukitaLevelGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EdukitaLevelGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type EdukitaLevelGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation';
  book?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelIdFilters = {
  OR?: InputMaybe<Array<EdukitaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelInsertInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type EdukitaLevelItem = {
  __typename?: 'EdukitaLevelItem';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelNameFilters = {
  OR?: InputMaybe<Array<EdukitaLevelNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelOrderBy = {
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type EdukitaLevelSelectItem = {
  __typename?: 'EdukitaLevelSelectItem';
  gaudiaLevel?: Maybe<EdukitaLevelGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EdukitaLevelSelectItemGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type EdukitaLevelUpdateInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelBooksRelation = {
  __typename?: 'GaudiaLevelBooksRelation';
  gaudiaLevel?: Maybe<GaudiaLevelBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<GaudiaLevelBooksRelationUnitsRelation>;
};


export type GaudiaLevelBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type GaudiaLevelBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type GaudiaLevelBooksRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelation';
  book?: Maybe<GaudiaLevelBooksRelationUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<GaudiaLevelBooksRelationUnitsRelationSubunitsRelation>;
};


export type GaudiaLevelBooksRelationUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationBookRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type GaudiaLevelEdukitaLevelsRelation = {
  __typename?: 'GaudiaLevelEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelFilters = {
  OR?: InputMaybe<Array<GaudiaLevelFiltersOr>>;
  id?: InputMaybe<GaudiaLevelIdFilters>;
  name?: InputMaybe<GaudiaLevelNameFilters>;
};

export type GaudiaLevelFiltersOr = {
  id?: InputMaybe<GaudiaLevelIdFilters>;
  name?: InputMaybe<GaudiaLevelNameFilters>;
};

export type GaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<GaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GaudiaLevelItem = {
  __typename?: 'GaudiaLevelItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelNameFilters = {
  OR?: InputMaybe<Array<GaudiaLevelNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type GaudiaLevelSelectItem = {
  __typename?: 'GaudiaLevelSelectItem';
  books: Array<GaudiaLevelBooksRelation>;
  edukitaLevels: Array<GaudiaLevelEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelSelectItemBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type GaudiaLevelSelectItemEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type GaudiaLevelUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetStudentPaginated = {
  __typename?: 'GetStudentPaginated';
  pagination?: Maybe<Pagination>;
  result?: Maybe<Array<Maybe<GetStudentPaginatedItem>>>;
};

export type GetStudentPaginatedItem = {
  __typename?: 'GetStudentPaginatedItem';
  parent?: Maybe<Parent>;
  student?: Maybe<Student>;
};

export type InnerOrder = {
  direction: OrderDirection;
  /** Priority of current field */
  priority: Scalars['Int']['input'];
};

export type LastWorkedWorksheet = {
  __typename?: 'LastWorkedWorksheet';
  book?: Maybe<LastWorkedWorksheetBook>;
  pages?: Maybe<Array<Maybe<WorksheetPage>>>;
  subunit?: Maybe<LastWorkedWorksheetSubunit>;
  updatedAt: Scalars['String']['output'];
  worksheetId: Scalars['Int']['output'];
  worksheetName: Scalars['String']['output'];
};

export type LastWorkedWorksheetBook = {
  __typename?: 'LastWorkedWorksheetBook';
  bookId: Scalars['Int']['output'];
  bookName: Scalars['String']['output'];
};

export type LastWorkedWorksheetSubunit = {
  __typename?: 'LastWorkedWorksheetSubunit';
  subunitId: Scalars['Int']['output'];
  subunitName: Scalars['String']['output'];
};

export type MarkedQuestion = {
  __typename?: 'MarkedQuestion';
  id: Scalars['Int']['output'];
  points: Scalars['Float']['output'];
};

export type MarkedQuestionFilters = {
  OR?: InputMaybe<Array<MarkedQuestionFiltersOr>>;
  id?: InputMaybe<MarkedQuestionIdFilters>;
  markingSessionId?: InputMaybe<MarkedQuestionMarkingSessionIdFilters>;
  points?: InputMaybe<MarkedQuestionPointsFilters>;
  worksheetPageQuestionId?: InputMaybe<MarkedQuestionWorksheetPageQuestionIdFilters>;
};

export type MarkedQuestionFiltersOr = {
  id?: InputMaybe<MarkedQuestionIdFilters>;
  markingSessionId?: InputMaybe<MarkedQuestionMarkingSessionIdFilters>;
  points?: InputMaybe<MarkedQuestionPointsFilters>;
  worksheetPageQuestionId?: InputMaybe<MarkedQuestionWorksheetPageQuestionIdFilters>;
};

export type MarkedQuestionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionInput = {
  points: Scalars['Int']['input'];
  worksheetPageQuestionId: Scalars['Int']['input'];
};

export type MarkedQuestionInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  points: Scalars['Int']['input'];
  worksheetPageQuestionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkedQuestionItem = {
  __typename?: 'MarkedQuestionItem';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionMarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionMarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionMarkingSessionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionOrderBy = {
  id?: InputMaybe<InnerOrder>;
  markingSessionId?: InputMaybe<InnerOrder>;
  points?: InputMaybe<InnerOrder>;
  worksheetPageQuestionId?: InputMaybe<InnerOrder>;
};

export type MarkedQuestionPointsFilters = {
  OR?: InputMaybe<Array<MarkedQuestionPointsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionPointsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionSelectItem = {
  __typename?: 'MarkedQuestionSelectItem';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkedQuestionMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkedQuestionWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionSelectItemMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkedQuestionSelectItemWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageQuestionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionWorksheetPageQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionCreatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionFilters = {
  OR?: InputMaybe<Array<MarkingSessionFiltersOr>>;
  createdAt?: InputMaybe<MarkingSessionCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<MarkingSessionWorksheetSetAssignmentIdFilters>;
};

export type MarkingSessionFiltersOr = {
  createdAt?: InputMaybe<MarkingSessionCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<MarkingSessionWorksheetSetAssignmentIdFilters>;
};

export type MarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionItem = {
  __typename?: 'MarkingSessionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  worksheetSetAssignmentId?: InputMaybe<InnerOrder>;
};

export type MarkingSessionOverrideCreatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideFiltersOr>>;
  createdAt?: InputMaybe<MarkingSessionOverrideCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionOverrideIdFilters>;
  markingSessionId?: InputMaybe<MarkingSessionOverrideMarkingSessionIdFilters>;
  overrideStatus?: InputMaybe<MarkingSessionOverrideOverrideStatusFilters>;
  remarks?: InputMaybe<MarkingSessionOverrideRemarksFilters>;
  updatedAt?: InputMaybe<MarkingSessionOverrideUpdatedAtFilters>;
  worksheetSetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetVersionIdFilters>;
};

export type MarkingSessionOverrideFiltersOr = {
  createdAt?: InputMaybe<MarkingSessionOverrideCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionOverrideIdFilters>;
  markingSessionId?: InputMaybe<MarkingSessionOverrideMarkingSessionIdFilters>;
  overrideStatus?: InputMaybe<MarkingSessionOverrideOverrideStatusFilters>;
  remarks?: InputMaybe<MarkingSessionOverrideRemarksFilters>;
  updatedAt?: InputMaybe<MarkingSessionOverrideUpdatedAtFilters>;
  worksheetSetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetVersionIdFilters>;
};

export type MarkingSessionOverrideIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionOverrideItem = {
  __typename?: 'MarkingSessionOverrideItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideMarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideMarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  markingSessionId?: InputMaybe<InnerOrder>;
  overrideStatus?: InputMaybe<InnerOrder>;
  remarks?: InputMaybe<InnerOrder>;
  updatedAt?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type MarkingSessionOverrideOverrideStatusFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideOverrideStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideOverrideStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideRemarksFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideRemarksfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideRemarksfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideSelectItem = {
  __typename?: 'MarkingSessionOverrideSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelation>;
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideSelectItemMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  overrideStatus?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionOverrideUpdatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideUpdatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideUpdatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionResponse = {
  __typename?: 'MarkingSessionResponse';
  sessionId: Scalars['Int']['output'];
};

export type MarkingSessionSelectItem = {
  __typename?: 'MarkingSessionSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionSelectItemMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionSelectItemWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionSummary = {
  __typename?: 'MarkingSessionSummary';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheets?: Maybe<Array<Maybe<Worksheet>>>;
};

export type MarkingSessionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionWorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteFromBook: Array<BookItem>;
  deleteFromEdukitaLevel: Array<EdukitaLevelItem>;
  deleteFromGaudiaLevel: Array<GaudiaLevelItem>;
  deleteFromMarkedQuestion: Array<MarkedQuestionItem>;
  deleteFromMarkingSession: Array<MarkingSessionItem>;
  deleteFromMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  deleteFromSubunit: Array<SubunitItem>;
  deleteFromUnit: Array<UnitItem>;
  deleteFromWorksheet: Array<WorksheetItem>;
  deleteFromWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  deleteFromWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  deleteFromWorksheetPage: Array<WorksheetPageItem>;
  deleteFromWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  deleteFromWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  deleteFromWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  deleteFromWorksheetSet: Array<WorksheetSetItem>;
  deleteFromWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  deleteFromWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  deleteFromWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  deleteFromWorksheetVersion: Array<WorksheetVersionItem>;
  deleteFromWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  insertIntoBook: Array<BookItem>;
  insertIntoBookSingle?: Maybe<BookItem>;
  insertIntoEdukitaLevel: Array<EdukitaLevelItem>;
  insertIntoEdukitaLevelSingle?: Maybe<EdukitaLevelItem>;
  insertIntoGaudiaLevel: Array<GaudiaLevelItem>;
  insertIntoGaudiaLevelSingle?: Maybe<GaudiaLevelItem>;
  insertIntoMarkedQuestion: Array<MarkedQuestionItem>;
  insertIntoMarkedQuestionSingle?: Maybe<MarkedQuestionItem>;
  insertIntoMarkingSession: Array<MarkingSessionItem>;
  insertIntoMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  insertIntoMarkingSessionOverrideSingle?: Maybe<MarkingSessionOverrideItem>;
  insertIntoMarkingSessionSingle?: Maybe<MarkingSessionItem>;
  insertIntoSubunit: Array<SubunitItem>;
  insertIntoSubunitSingle?: Maybe<SubunitItem>;
  insertIntoUnit: Array<UnitItem>;
  insertIntoUnitSingle?: Maybe<UnitItem>;
  insertIntoWorksheet: Array<WorksheetItem>;
  insertIntoWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  insertIntoWorksheetAnswerKeySingle?: Maybe<WorksheetAnswerKeyItem>;
  insertIntoWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  insertIntoWorksheetAnswerKeyVersionSingle?: Maybe<WorksheetAnswerKeyVersionItem>;
  insertIntoWorksheetPage: Array<WorksheetPageItem>;
  insertIntoWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  insertIntoWorksheetPageAnnotationSingle?: Maybe<WorksheetPageAnnotationItem>;
  insertIntoWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  insertIntoWorksheetPageQuestionSingle?: Maybe<WorksheetPageQuestionItem>;
  insertIntoWorksheetPageSingle?: Maybe<WorksheetPageItem>;
  insertIntoWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  insertIntoWorksheetPageVersionSingle?: Maybe<WorksheetPageVersionItem>;
  insertIntoWorksheetSet: Array<WorksheetSetItem>;
  insertIntoWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  insertIntoWorksheetSetAssignmentSingle?: Maybe<WorksheetSetAssignmentItem>;
  insertIntoWorksheetSetSingle?: Maybe<WorksheetSetItem>;
  insertIntoWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  insertIntoWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  insertIntoWorksheetSetVersionItemSingle?: Maybe<WorksheetSetVersionItemItem>;
  insertIntoWorksheetSetVersionSingle?: Maybe<WorksheetSetVersionItem>;
  insertIntoWorksheetSingle?: Maybe<WorksheetItem>;
  insertIntoWorksheetVersion: Array<WorksheetVersionItem>;
  insertIntoWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  insertIntoWorksheetVersionItemSingle?: Maybe<WorksheetVersionItemItem>;
  insertIntoWorksheetVersionSingle?: Maybe<WorksheetVersionItem>;
  updateBook: Array<BookItem>;
  updateEdukitaLevel: Array<EdukitaLevelItem>;
  updateGaudiaLevel: Array<GaudiaLevelItem>;
  updateMarkedQuestion: Array<MarkedQuestionItem>;
  updateMarkingSession: Array<MarkingSessionItem>;
  updateMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  updateSubunit: Array<SubunitItem>;
  updateUnit: Array<UnitItem>;
  updateWorksheet: Array<WorksheetItem>;
  updateWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  updateWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  updateWorksheetPage: Array<WorksheetPageItem>;
  updateWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  updateWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  updateWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  updateWorksheetSet: Array<WorksheetSetItem>;
  updateWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  updateWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  updateWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  updateWorksheetVersion: Array<WorksheetVersionItem>;
  updateWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  upsertMarkingSession?: Maybe<MarkingSessionResponse>;
  upsertMarkingSessionOverride?: Maybe<UpsertMarkingSessionOverride>;
  upsertWorksheetPageAnnotation?: Maybe<WorksheetPageAnnotation>;
};


export type MutationDeleteFromBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MutationDeleteFromEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MutationDeleteFromGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MutationDeleteFromMarkedQuestionArgs = {
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MutationDeleteFromMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MutationDeleteFromMarkingSessionOverrideArgs = {
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type MutationDeleteFromSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};


export type MutationDeleteFromUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MutationDeleteFromWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MutationDeleteFromWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MutationDeleteFromWorksheetAnswerKeyVersionArgs = {
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MutationDeleteFromWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MutationDeleteFromWorksheetPageAnnotationArgs = {
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type MutationDeleteFromWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type MutationDeleteFromWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MutationDeleteFromWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MutationDeleteFromWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MutationDeleteFromWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MutationDeleteFromWorksheetSetVersionItemArgs = {
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MutationDeleteFromWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type MutationDeleteFromWorksheetVersionItemArgs = {
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type MutationInsertIntoBookArgs = {
  values: Array<BookInsertInput>;
};


export type MutationInsertIntoBookSingleArgs = {
  values: BookInsertInput;
};


export type MutationInsertIntoEdukitaLevelArgs = {
  values: Array<EdukitaLevelInsertInput>;
};


export type MutationInsertIntoEdukitaLevelSingleArgs = {
  values: EdukitaLevelInsertInput;
};


export type MutationInsertIntoGaudiaLevelArgs = {
  values: Array<GaudiaLevelInsertInput>;
};


export type MutationInsertIntoGaudiaLevelSingleArgs = {
  values: GaudiaLevelInsertInput;
};


export type MutationInsertIntoMarkedQuestionArgs = {
  values: Array<MarkedQuestionInsertInput>;
};


export type MutationInsertIntoMarkedQuestionSingleArgs = {
  values: MarkedQuestionInsertInput;
};


export type MutationInsertIntoMarkingSessionArgs = {
  values: Array<MarkingSessionInsertInput>;
};


export type MutationInsertIntoMarkingSessionOverrideArgs = {
  values: Array<MarkingSessionOverrideInsertInput>;
};


export type MutationInsertIntoMarkingSessionOverrideSingleArgs = {
  values: MarkingSessionOverrideInsertInput;
};


export type MutationInsertIntoMarkingSessionSingleArgs = {
  values: MarkingSessionInsertInput;
};


export type MutationInsertIntoSubunitArgs = {
  values: Array<SubunitInsertInput>;
};


export type MutationInsertIntoSubunitSingleArgs = {
  values: SubunitInsertInput;
};


export type MutationInsertIntoUnitArgs = {
  values: Array<UnitInsertInput>;
};


export type MutationInsertIntoUnitSingleArgs = {
  values: UnitInsertInput;
};


export type MutationInsertIntoWorksheetArgs = {
  values: Array<WorksheetInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeyArgs = {
  values: Array<WorksheetAnswerKeyInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeySingleArgs = {
  values: WorksheetAnswerKeyInsertInput;
};


export type MutationInsertIntoWorksheetAnswerKeyVersionArgs = {
  values: Array<WorksheetAnswerKeyVersionInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeyVersionSingleArgs = {
  values: WorksheetAnswerKeyVersionInsertInput;
};


export type MutationInsertIntoWorksheetPageArgs = {
  values: Array<WorksheetPageInsertInput>;
};


export type MutationInsertIntoWorksheetPageAnnotationArgs = {
  values: Array<WorksheetPageAnnotationInsertInput>;
};


export type MutationInsertIntoWorksheetPageAnnotationSingleArgs = {
  values: WorksheetPageAnnotationInsertInput;
};


export type MutationInsertIntoWorksheetPageQuestionArgs = {
  values: Array<WorksheetPageQuestionInsertInput>;
};


export type MutationInsertIntoWorksheetPageQuestionSingleArgs = {
  values: WorksheetPageQuestionInsertInput;
};


export type MutationInsertIntoWorksheetPageSingleArgs = {
  values: WorksheetPageInsertInput;
};


export type MutationInsertIntoWorksheetPageVersionArgs = {
  values: Array<WorksheetPageVersionInsertInput>;
};


export type MutationInsertIntoWorksheetPageVersionSingleArgs = {
  values: WorksheetPageVersionInsertInput;
};


export type MutationInsertIntoWorksheetSetArgs = {
  values: Array<WorksheetSetInsertInput>;
};


export type MutationInsertIntoWorksheetSetAssignmentArgs = {
  values: Array<WorksheetSetAssignmentInsertInput>;
};


export type MutationInsertIntoWorksheetSetAssignmentSingleArgs = {
  values: WorksheetSetAssignmentInsertInput;
};


export type MutationInsertIntoWorksheetSetSingleArgs = {
  values: WorksheetSetInsertInput;
};


export type MutationInsertIntoWorksheetSetVersionArgs = {
  values: Array<WorksheetSetVersionInsertInput>;
};


export type MutationInsertIntoWorksheetSetVersionItemArgs = {
  values: Array<WorksheetSetVersionItemInsertInput>;
};


export type MutationInsertIntoWorksheetSetVersionItemSingleArgs = {
  values: WorksheetSetVersionItemInsertInput;
};


export type MutationInsertIntoWorksheetSetVersionSingleArgs = {
  values: WorksheetSetVersionInsertInput;
};


export type MutationInsertIntoWorksheetSingleArgs = {
  values: WorksheetInsertInput;
};


export type MutationInsertIntoWorksheetVersionArgs = {
  values: Array<WorksheetVersionInsertInput>;
};


export type MutationInsertIntoWorksheetVersionItemArgs = {
  values: Array<WorksheetVersionItemInsertInput>;
};


export type MutationInsertIntoWorksheetVersionItemSingleArgs = {
  values: WorksheetVersionItemInsertInput;
};


export type MutationInsertIntoWorksheetVersionSingleArgs = {
  values: WorksheetVersionInsertInput;
};


export type MutationUpdateBookArgs = {
  set: BookUpdateInput;
  where?: InputMaybe<BookFilters>;
};


export type MutationUpdateEdukitaLevelArgs = {
  set: EdukitaLevelUpdateInput;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MutationUpdateGaudiaLevelArgs = {
  set: GaudiaLevelUpdateInput;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MutationUpdateMarkedQuestionArgs = {
  set: MarkedQuestionUpdateInput;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MutationUpdateMarkingSessionArgs = {
  set: MarkingSessionUpdateInput;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MutationUpdateMarkingSessionOverrideArgs = {
  set: MarkingSessionOverrideUpdateInput;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type MutationUpdateSubunitArgs = {
  set: SubunitUpdateInput;
  where?: InputMaybe<SubunitFilters>;
};


export type MutationUpdateUnitArgs = {
  set: UnitUpdateInput;
  where?: InputMaybe<UnitFilters>;
};


export type MutationUpdateWorksheetArgs = {
  set: WorksheetUpdateInput;
  where?: InputMaybe<WorksheetFilters>;
};


export type MutationUpdateWorksheetAnswerKeyArgs = {
  set: WorksheetAnswerKeyUpdateInput;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MutationUpdateWorksheetAnswerKeyVersionArgs = {
  set: WorksheetAnswerKeyVersionUpdateInput;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MutationUpdateWorksheetPageArgs = {
  set: WorksheetPageUpdateInput;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MutationUpdateWorksheetPageAnnotationArgs = {
  set: WorksheetPageAnnotationUpdateInput;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type MutationUpdateWorksheetPageQuestionArgs = {
  set: WorksheetPageQuestionUpdateInput;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type MutationUpdateWorksheetPageVersionArgs = {
  set: WorksheetPageVersionUpdateInput;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MutationUpdateWorksheetSetArgs = {
  set: WorksheetSetUpdateInput;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MutationUpdateWorksheetSetAssignmentArgs = {
  set: WorksheetSetAssignmentUpdateInput;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MutationUpdateWorksheetSetVersionArgs = {
  set: WorksheetSetVersionUpdateInput;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MutationUpdateWorksheetSetVersionItemArgs = {
  set: WorksheetSetVersionItemUpdateInput;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MutationUpdateWorksheetVersionArgs = {
  set: WorksheetVersionUpdateInput;
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type MutationUpdateWorksheetVersionItemArgs = {
  set: WorksheetVersionItemUpdateInput;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type MutationUpsertMarkingSessionArgs = {
  markedQuestions: Array<InputMaybe<MarkedQuestionInput>>;
  worksheetSetAssignmentId: Scalars['Int']['input'];
};


export type MutationUpsertMarkingSessionOverrideArgs = {
  markingSessionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
};


export type MutationUpsertWorksheetPageAnnotationArgs = {
  drawing?: InputMaybe<Scalars['JSON']['input']>;
  garageUserId: Scalars['Int']['input'];
  role: Scalars['String']['input'];
  textboxes?: InputMaybe<Scalars['JSON']['input']>;
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
};

/** Order by direction */
export enum OrderDirection {
  /** Ascending order */
  Asc = 'asc',
  /** Descending order */
  Desc = 'desc'
}

export type Page = {
  __typename?: 'Page';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  questions?: Maybe<Array<Maybe<Question>>>;
};

export type PageVersionAnnotation = {
  __typename?: 'PageVersionAnnotation';
  drawing?: Maybe<Array<Maybe<PageVersionDrawing>>>;
  id: Scalars['Int']['output'];
  textboxes?: Maybe<Array<Maybe<PageVersionTextbox>>>;
};

export type PageVersionAnnotations = {
  __typename?: 'PageVersionAnnotations';
  student?: Maybe<Array<Maybe<PageVersionAnnotation>>>;
  teacher?: Maybe<Array<Maybe<PageVersionAnnotation>>>;
};

export type PageVersionAnswerKey = {
  __typename?: 'PageVersionAnswerKey';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionDrawing = {
  __typename?: 'PageVersionDrawing';
  color?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  stroke?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionMarkedQuestion = {
  __typename?: 'PageVersionMarkedQuestion';
  id: Scalars['Int']['output'];
  points?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionPage = {
  __typename?: 'PageVersionPage';
  annotations?: Maybe<PageVersionAnnotations>;
  answerKey?: Maybe<PageVersionAnswerKey>;
  id: Scalars['Int']['output'];
  page?: Maybe<PageVersionPageDetail>;
  questions?: Maybe<Array<Maybe<PageVersionQuestion>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionPageDetail = {
  __typename?: 'PageVersionPageDetail';
  name?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionQuestion = {
  __typename?: 'PageVersionQuestion';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  markedQuestion?: Maybe<PageVersionMarkedQuestion>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionTextbox = {
  __typename?: 'PageVersionTextbox';
  fontSize?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<PageVersionTextboxPosition>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageVersionTextboxPosition = {
  __typename?: 'PageVersionTextboxPosition';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  items?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  per_page?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type Parent = {
  __typename?: 'Parent';
  honorific?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registration_flow_status?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  book: Array<BookSelectItem>;
  bookSingle?: Maybe<BookSelectItem>;
  edukitaLevel: Array<EdukitaLevelSelectItem>;
  edukitaLevelSingle?: Maybe<EdukitaLevelSelectItem>;
  gaudiaLevel: Array<GaudiaLevelSelectItem>;
  gaudiaLevelSingle?: Maybe<GaudiaLevelSelectItem>;
  getAssignmentDetail?: Maybe<AssignmentDetail>;
  getAssignments?: Maybe<Array<Maybe<Assignment>>>;
  getLastWorkedWorksheetPage?: Maybe<WorkedWorksheetPage>;
  getLastWorkedWorksheets?: Maybe<Array<Maybe<LastWorkedWorksheet>>>;
  getMarkingSessionSummary?: Maybe<MarkingSessionSummary>;
  getMe?: Maybe<User>;
  getStaffSchedule?: Maybe<Array<Maybe<StaffSchedule>>>;
  getStudentPaginated?: Maybe<GetStudentPaginated>;
  getStudentsByClassroomSession?: Maybe<ClassroomSessionWithStudents>;
  getWorksheetDetail?: Maybe<WorksheetDetail>;
  getWorksheetPageDetail?: Maybe<WorksheetPageDetail>;
  getWorksheetPageVersionDetail?: Maybe<PageVersionPage>;
  getWorksheetSetDetail?: Maybe<WorksheetSetDetail>;
  getWorksheetSetVersionDetail?: Maybe<WorksheetSetVersionDetail>;
  getWorksheetVersionDetail?: Maybe<WorksheetVersionDetail>;
  markedQuestion: Array<MarkedQuestionSelectItem>;
  markedQuestionSingle?: Maybe<MarkedQuestionSelectItem>;
  markingSession: Array<MarkingSessionSelectItem>;
  markingSessionOverride: Array<MarkingSessionOverrideSelectItem>;
  markingSessionOverrideSingle?: Maybe<MarkingSessionOverrideSelectItem>;
  markingSessionSingle?: Maybe<MarkingSessionSelectItem>;
  subunit: Array<SubunitSelectItem>;
  subunitSingle?: Maybe<SubunitSelectItem>;
  unit: Array<UnitSelectItem>;
  unitSingle?: Maybe<UnitSelectItem>;
  worksheet: Array<WorksheetSelectItem>;
  worksheetAnswerKey: Array<WorksheetAnswerKeySelectItem>;
  worksheetAnswerKeySingle?: Maybe<WorksheetAnswerKeySelectItem>;
  worksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionSelectItem>;
  worksheetAnswerKeyVersionSingle?: Maybe<WorksheetAnswerKeyVersionSelectItem>;
  worksheetPage: Array<WorksheetPageSelectItem>;
  worksheetPageAnnotation: Array<WorksheetPageAnnotationSelectItem>;
  worksheetPageAnnotationSingle?: Maybe<WorksheetPageAnnotationSelectItem>;
  worksheetPageQuestion: Array<WorksheetPageQuestionSelectItem>;
  worksheetPageQuestionSingle?: Maybe<WorksheetPageQuestionSelectItem>;
  worksheetPageSingle?: Maybe<WorksheetPageSelectItem>;
  worksheetPageVersion: Array<WorksheetPageVersionSelectItem>;
  worksheetPageVersionSingle?: Maybe<WorksheetPageVersionSelectItem>;
  worksheetSet: Array<WorksheetSetSelectItem>;
  worksheetSetAssignment: Array<WorksheetSetAssignmentSelectItem>;
  worksheetSetAssignmentSingle?: Maybe<WorksheetSetAssignmentSelectItem>;
  worksheetSetSingle?: Maybe<WorksheetSetSelectItem>;
  worksheetSetVersion: Array<WorksheetSetVersionSelectItem>;
  worksheetSetVersionItem: Array<WorksheetSetVersionItemSelectItem>;
  worksheetSetVersionItemSingle?: Maybe<WorksheetSetVersionItemSelectItem>;
  worksheetSetVersionSingle?: Maybe<WorksheetSetVersionSelectItem>;
  worksheetSingle?: Maybe<WorksheetSelectItem>;
  worksheetVersion: Array<WorksheetVersionSelectItem>;
  worksheetVersionItem: Array<WorksheetVersionItemSelectItem>;
  worksheetVersionItemSingle?: Maybe<WorksheetVersionItemSelectItem>;
  worksheetVersionSingle?: Maybe<WorksheetVersionSelectItem>;
};


export type QueryBookArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type QueryBookSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type QueryEdukitaLevelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type QueryEdukitaLevelSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type QueryGaudiaLevelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GaudiaLevelOrderBy>;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type QueryGaudiaLevelSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GaudiaLevelOrderBy>;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type QueryGetAssignmentDetailArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetAssignmentsArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
};


export type QueryGetLastWorkedWorksheetPageArgs = {
  userId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetLastWorkedWorksheetsArgs = {
  dayEnd: Scalars['String']['input'];
  dayStart: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryGetMarkingSessionSummaryArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetStaffScheduleArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentPaginatedArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStudentsByClassroomSessionArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QueryGetWorksheetDetailArgs = {
  worksheetId: Scalars['Int']['input'];
};


export type QueryGetWorksheetPageDetailArgs = {
  worksheetPageId: Scalars['Int']['input'];
};


export type QueryGetWorksheetPageVersionDetailArgs = {
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
};


export type QueryGetWorksheetSetDetailArgs = {
  worksheetSetId: Scalars['Int']['input'];
};


export type QueryGetWorksheetSetVersionDetailArgs = {
  worksheetSetId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetWorksheetVersionDetailArgs = {
  worksheetId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
};


export type QueryMarkedQuestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type QueryMarkedQuestionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type QueryMarkingSessionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOrderBy>;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type QueryMarkingSessionOverrideArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOverrideOrderBy>;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type QueryMarkingSessionOverrideSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOverrideOrderBy>;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type QueryMarkingSessionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOrderBy>;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type QuerySubunitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};


export type QuerySubunitSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};


export type QueryUnitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};


export type QueryUnitSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};


export type QueryWorksheetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};


export type QueryWorksheetAnswerKeyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type QueryWorksheetAnswerKeySingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type QueryWorksheetAnswerKeyVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type QueryWorksheetAnswerKeyVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type QueryWorksheetPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageOrderBy>;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type QueryWorksheetPageAnnotationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageAnnotationOrderBy>;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type QueryWorksheetPageAnnotationSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageAnnotationOrderBy>;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type QueryWorksheetPageQuestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type QueryWorksheetPageQuestionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type QueryWorksheetPageSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageOrderBy>;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type QueryWorksheetPageVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type QueryWorksheetPageVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type QueryWorksheetSetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetOrderBy>;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type QueryWorksheetSetAssignmentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type QueryWorksheetSetAssignmentSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type QueryWorksheetSetSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetOrderBy>;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type QueryWorksheetSetVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type QueryWorksheetSetVersionItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type QueryWorksheetSetVersionItemSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type QueryWorksheetSetVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type QueryWorksheetSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};


export type QueryWorksheetVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionOrderBy>;
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type QueryWorksheetVersionItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type QueryWorksheetVersionItemSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type QueryWorksheetVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionOrderBy>;
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type Question = {
  __typename?: 'Question';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions?: Maybe<Array<Maybe<MarkedQuestion>>>;
  totalPoints: Scalars['Float']['output'];
};

export type Session = {
  __typename?: 'Session';
  bts_id?: Maybe<Scalars['String']['output']>;
  course_id?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  end_timestamp?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_offline?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  start_timestamp?: Maybe<Scalars['String']['output']>;
  teacher?: Maybe<Teacher>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  use_bts?: Maybe<Scalars['Boolean']['output']>;
};

export type SetVersionBook = {
  __typename?: 'SetVersionBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SetVersionSubunit = {
  __typename?: 'SetVersionSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StaffSchedule = {
  __typename?: 'StaffSchedule';
  day: Scalars['String']['output'];
  end_time: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_offline: Scalars['Boolean']['output'];
  start_time: Scalars['String']['output'];
  teacher?: Maybe<Teacher>;
  title: Scalars['String']['output'];
};

export type Student = {
  __typename?: 'Student';
  active_subscription?: Maybe<Scalars['Boolean']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_trial?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  package_group?: Maybe<Scalars['String']['output']>;
};

export type SubunitFilters = {
  OR?: InputMaybe<Array<SubunitFiltersOr>>;
  id?: InputMaybe<SubunitIdFilters>;
  name?: InputMaybe<SubunitNameFilters>;
  order?: InputMaybe<SubunitOrderFilters>;
  unitId?: InputMaybe<SubunitUnitIdFilters>;
};

export type SubunitFiltersOr = {
  id?: InputMaybe<SubunitIdFilters>;
  name?: InputMaybe<SubunitNameFilters>;
  order?: InputMaybe<SubunitOrderFilters>;
  unitId?: InputMaybe<SubunitUnitIdFilters>;
};

export type SubunitIdFilters = {
  OR?: InputMaybe<Array<SubunitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubunitItem = {
  __typename?: 'SubunitItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type SubunitNameFilters = {
  OR?: InputMaybe<Array<SubunitNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  order?: InputMaybe<InnerOrder>;
  unitId?: InputMaybe<InnerOrder>;
};

export type SubunitOrderFilters = {
  OR?: InputMaybe<Array<SubunitOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitSelectItem = {
  __typename?: 'SubunitSelectItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<SubunitUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<SubunitWorksheetsRelation>;
};


export type SubunitSelectItemUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type SubunitSelectItemWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type SubunitUnitIdFilters = {
  OR?: InputMaybe<Array<SubunitUnitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitUnitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitUnitRelation = {
  __typename?: 'SubunitUnitRelation';
  book?: Maybe<SubunitUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<SubunitUnitRelationSubunitsRelation>;
};


export type SubunitUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type SubunitUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type SubunitUnitRelationBookRelation = {
  __typename?: 'SubunitUnitRelationBookRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<SubunitUnitRelationBookRelationUnitsRelation>;
};


export type SubunitUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type SubunitUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationBookRelationUnitsRelation = {
  __typename?: 'SubunitUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationSubunitsRelation = {
  __typename?: 'SubunitUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type SubunitUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubunitWorksheetsRelation = {
  __typename?: 'SubunitWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<SubunitWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type SubunitWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type SubunitWorksheetsRelationSubunitRelation = {
  __typename?: 'SubunitWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type Teacher = {
  __typename?: 'Teacher';
  email?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnitBookIdFilters = {
  OR?: InputMaybe<Array<UnitBookIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitBookIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitBookRelation = {
  __typename?: 'UnitBookRelation';
  gaudiaLevel?: Maybe<UnitBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<UnitBookRelationUnitsRelation>;
};


export type UnitBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type UnitBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type UnitBookRelationGaudiaLevelRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelation';
  books: Array<UnitBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type UnitBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitBookRelationUnitsRelation = {
  __typename?: 'UnitBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelIdFilters = {
  OR?: InputMaybe<Array<UnitEdukitaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitEdukitaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitEdukitaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelation';
  gaudiaLevel?: Maybe<UnitEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitFilters = {
  OR?: InputMaybe<Array<UnitFiltersOr>>;
  bookId?: InputMaybe<UnitBookIdFilters>;
  edukitaLevelId?: InputMaybe<UnitEdukitaLevelIdFilters>;
  id?: InputMaybe<UnitIdFilters>;
  name?: InputMaybe<UnitNameFilters>;
};

export type UnitFiltersOr = {
  bookId?: InputMaybe<UnitBookIdFilters>;
  edukitaLevelId?: InputMaybe<UnitEdukitaLevelIdFilters>;
  id?: InputMaybe<UnitIdFilters>;
  name?: InputMaybe<UnitNameFilters>;
};

export type UnitIdFilters = {
  OR?: InputMaybe<Array<UnitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitInsertInput = {
  bookId?: InputMaybe<Scalars['Int']['input']>;
  edukitaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UnitItem = {
  __typename?: 'UnitItem';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitNameFilters = {
  OR?: InputMaybe<Array<UnitNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitOrderBy = {
  bookId?: InputMaybe<InnerOrder>;
  edukitaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type UnitSelectItem = {
  __typename?: 'UnitSelectItem';
  book?: Maybe<UnitBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<UnitEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<UnitSubunitsRelation>;
};


export type UnitSelectItemBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type UnitSelectItemEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type UnitSelectItemSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type UnitSubunitsRelation = {
  __typename?: 'UnitSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<UnitSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<UnitSubunitsRelationWorksheetsRelation>;
};


export type UnitSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type UnitSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type UnitSubunitsRelationUnitRelation = {
  __typename?: 'UnitSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitSubunitsRelationWorksheetsRelation = {
  __typename?: 'UnitSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<UnitSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type UnitSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type UnitSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'UnitSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type UnitUpdateInput = {
  bookId?: InputMaybe<Scalars['Int']['input']>;
  edukitaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMarkingSessionOverride = {
  __typename?: 'UpsertMarkingSessionOverride';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  worksheetSetVersionId: Scalars['Int']['output'];
  worksheetVersionId: Scalars['Int']['output'];
};

export type User = Student | Teacher;

export type VersionWorksheetDetail = {
  __typename?: 'VersionWorksheetDetail';
  book?: Maybe<SetVersionBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<VersionWorksheetPageDetail>>>;
  subunit?: Maybe<SetVersionSubunit>;
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type VersionWorksheetPageDetail = {
  __typename?: 'VersionWorksheetPageDetail';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  questions?: Maybe<Array<Maybe<VersionWorksheetPageQuestion>>>;
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type VersionWorksheetPageQuestion = {
  __typename?: 'VersionWorksheetPageQuestion';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Float']['output'];
};

export type WorkedWorksheetPage = {
  __typename?: 'WorkedWorksheetPage';
  annotationId: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  pageName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  pageVersionId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Worksheet = {
  __typename?: 'Worksheet';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<Page>>>;
};

export type WorksheetAgeRangeEndFilters = {
  OR?: InputMaybe<Array<WorksheetAgeRangeEndfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeEndfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeStartFilters = {
  OR?: InputMaybe<Array<WorksheetAgeRangeStartfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeStartfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyFiltersOr>>;
  id?: InputMaybe<WorksheetAnswerKeyIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetAnswerKeyWorksheetPageVersionIdFilters>;
};

export type WorksheetAnswerKeyFiltersOr = {
  id?: InputMaybe<WorksheetAnswerKeyIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetAnswerKeyWorksheetPageVersionIdFilters>;
};

export type WorksheetAnswerKeyIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyItem = {
  __typename?: 'WorksheetAnswerKeyItem';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetAnswerKeySelectItem = {
  __typename?: 'WorksheetAnswerKeySelectItem';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeySelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetAnswerKeySelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionFilenameFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionFilenamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionFilenamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionFiltersOr>>;
  filename?: InputMaybe<WorksheetAnswerKeyVersionFilenameFilters>;
  id?: InputMaybe<WorksheetAnswerKeyVersionIdFilters>;
  version?: InputMaybe<WorksheetAnswerKeyVersionVersionFilters>;
  worksheetAnswerKeyId?: InputMaybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters>;
};

export type WorksheetAnswerKeyVersionFiltersOr = {
  filename?: InputMaybe<WorksheetAnswerKeyVersionFilenameFilters>;
  id?: InputMaybe<WorksheetAnswerKeyVersionIdFilters>;
  version?: InputMaybe<WorksheetAnswerKeyVersionVersionFilters>;
  worksheetAnswerKeyId?: InputMaybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters>;
};

export type WorksheetAnswerKeyVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionInsertInput = {
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetAnswerKeyId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionItem = {
  __typename?: 'WorksheetAnswerKeyVersionItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionOrderBy = {
  filename?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetAnswerKeyId?: InputMaybe<InnerOrder>;
};

export type WorksheetAnswerKeyVersionSelectItem = {
  __typename?: 'WorksheetAnswerKeyVersionSelectItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionSelectItemWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetAnswerKeyVersionUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetAnswerKeyId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetBookOrderFilters = {
  OR?: InputMaybe<Array<WorksheetBookOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetBookOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDescriptionFilters = {
  OR?: InputMaybe<Array<WorksheetDescriptionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDescriptionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDetail = {
  __typename?: 'WorksheetDetail';
  book?: Maybe<WorksheetDetailBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunit?: Maybe<WorksheetDetailSubunit>;
  versions?: Maybe<Array<Maybe<WorksheetVersion>>>;
};

export type WorksheetDetailBook = {
  __typename?: 'WorksheetDetailBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetDetailSubunit = {
  __typename?: 'WorksheetDetailSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetFilters = {
  OR?: InputMaybe<Array<WorksheetFiltersOr>>;
  ageRangeEnd?: InputMaybe<WorksheetAgeRangeEndFilters>;
  ageRangeStart?: InputMaybe<WorksheetAgeRangeStartFilters>;
  bookOrder?: InputMaybe<WorksheetBookOrderFilters>;
  description?: InputMaybe<WorksheetDescriptionFilters>;
  id?: InputMaybe<WorksheetIdFilters>;
  name?: InputMaybe<WorksheetNameFilters>;
  schoolGradeEnd?: InputMaybe<WorksheetSchoolGradeEndFilters>;
  schoolGradeStart?: InputMaybe<WorksheetSchoolGradeStartFilters>;
  subunitId?: InputMaybe<WorksheetSubunitIdFilters>;
  textIdentifier?: InputMaybe<WorksheetTextIdentifierFilters>;
};

export type WorksheetFiltersOr = {
  ageRangeEnd?: InputMaybe<WorksheetAgeRangeEndFilters>;
  ageRangeStart?: InputMaybe<WorksheetAgeRangeStartFilters>;
  bookOrder?: InputMaybe<WorksheetBookOrderFilters>;
  description?: InputMaybe<WorksheetDescriptionFilters>;
  id?: InputMaybe<WorksheetIdFilters>;
  name?: InputMaybe<WorksheetNameFilters>;
  schoolGradeEnd?: InputMaybe<WorksheetSchoolGradeEndFilters>;
  schoolGradeStart?: InputMaybe<WorksheetSchoolGradeStartFilters>;
  subunitId?: InputMaybe<WorksheetSubunitIdFilters>;
  textIdentifier?: InputMaybe<WorksheetTextIdentifierFilters>;
};

export type WorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetInsertInput = {
  ageRangeEnd: Scalars['Int']['input'];
  ageRangeStart: Scalars['Int']['input'];
  bookOrder: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  schoolGradeEnd: Scalars['String']['input'];
  schoolGradeStart: Scalars['String']['input'];
  subunitId?: InputMaybe<Scalars['Int']['input']>;
  textIdentifier: Scalars['String']['input'];
};

export type WorksheetItem = {
  __typename?: 'WorksheetItem';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetNameFilters = {
  OR?: InputMaybe<Array<WorksheetNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetOrderBy = {
  ageRangeEnd?: InputMaybe<InnerOrder>;
  ageRangeStart?: InputMaybe<InnerOrder>;
  bookOrder?: InputMaybe<InnerOrder>;
  description?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  schoolGradeEnd?: InputMaybe<InnerOrder>;
  schoolGradeStart?: InputMaybe<InnerOrder>;
  subunitId?: InputMaybe<InnerOrder>;
  textIdentifier?: InputMaybe<InnerOrder>;
};

export type WorksheetPage = {
  __typename?: 'WorksheetPage';
  filename?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['Int']['output'];
  pageName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  pageVersionId: Scalars['Int']['output'];
};

export type WorksheetPageAnnotation = {
  __typename?: 'WorksheetPageAnnotation';
  drawing?: Maybe<Scalars['JSON']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  textboxes?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  worksheetPageVersionId: Scalars['Int']['output'];
};

export type WorksheetPageAnnotationCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationDrawingFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationDrawingfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationDrawingfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationFiltersOr>>;
  createdAt?: InputMaybe<WorksheetPageAnnotationCreatedAtFilters>;
  drawing?: InputMaybe<WorksheetPageAnnotationDrawingFilters>;
  garageUserId?: InputMaybe<WorksheetPageAnnotationGarageUserIdFilters>;
  id?: InputMaybe<WorksheetPageAnnotationIdFilters>;
  role?: InputMaybe<WorksheetPageAnnotationRoleFilters>;
  textboxes?: InputMaybe<WorksheetPageAnnotationTextboxesFilters>;
  updatedAt?: InputMaybe<WorksheetPageAnnotationUpdatedAtFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageAnnotationWorksheetPageVersionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<WorksheetPageAnnotationWorksheetSetAssignmentIdFilters>;
};

export type WorksheetPageAnnotationFiltersOr = {
  createdAt?: InputMaybe<WorksheetPageAnnotationCreatedAtFilters>;
  drawing?: InputMaybe<WorksheetPageAnnotationDrawingFilters>;
  garageUserId?: InputMaybe<WorksheetPageAnnotationGarageUserIdFilters>;
  id?: InputMaybe<WorksheetPageAnnotationIdFilters>;
  role?: InputMaybe<WorksheetPageAnnotationRoleFilters>;
  textboxes?: InputMaybe<WorksheetPageAnnotationTextboxesFilters>;
  updatedAt?: InputMaybe<WorksheetPageAnnotationUpdatedAtFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageAnnotationWorksheetPageVersionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<WorksheetPageAnnotationWorksheetSetAssignmentIdFilters>;
};

export type WorksheetPageAnnotationGarageUserIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationGarageUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationGarageUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  drawing?: InputMaybe<Scalars['String']['input']>;
  garageUserId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageAnnotationItem = {
  __typename?: 'WorksheetPageAnnotationItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  /** JSON */
  drawing?: Maybe<Scalars['String']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  drawing?: InputMaybe<InnerOrder>;
  garageUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  role?: InputMaybe<InnerOrder>;
  textboxes?: InputMaybe<InnerOrder>;
  updatedAt?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
  worksheetSetAssignmentId?: InputMaybe<InnerOrder>;
};

export enum WorksheetPageAnnotationRoleEnum {
  /** Value: ops */
  Ops = 'ops',
  /** Value: parent */
  Parent = 'parent',
  /** Value: student */
  Student = 'student',
  /** Value: teacher */
  Teacher = 'teacher'
}

export type WorksheetPageAnnotationRoleFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationRolefiltersOr>>;
  eq?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  lte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ne?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationRolefiltersOr = {
  eq?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  lte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ne?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationSelectItem = {
  __typename?: 'WorksheetPageAnnotationSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  /** JSON */
  drawing?: Maybe<Scalars['String']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationSelectItemWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationTextboxesFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationTextboxesfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationTextboxesfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  drawing?: InputMaybe<Scalars['String']['input']>;
  garageUserId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  /** JSON */
  textboxes?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageAnnotationUpdatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationUpdatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationUpdatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationWorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageDetail = {
  __typename?: 'WorksheetPageDetail';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions?: Maybe<Array<Maybe<WorksheetPageVersion>>>;
};

export type WorksheetPageFilters = {
  OR?: InputMaybe<Array<WorksheetPageFiltersOr>>;
  id?: InputMaybe<WorksheetPageIdFilters>;
  name?: InputMaybe<WorksheetPageNameFilters>;
  pageNumber?: InputMaybe<WorksheetPagePageNumberFilters>;
  worksheetId?: InputMaybe<WorksheetPageWorksheetIdFilters>;
};

export type WorksheetPageFiltersOr = {
  id?: InputMaybe<WorksheetPageIdFilters>;
  name?: InputMaybe<WorksheetPageNameFilters>;
  pageNumber?: InputMaybe<WorksheetPagePageNumberFilters>;
  worksheetId?: InputMaybe<WorksheetPageWorksheetIdFilters>;
};

export type WorksheetPageIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageItem = {
  __typename?: 'WorksheetPageItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageNameFilters = {
  OR?: InputMaybe<Array<WorksheetPageNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  pageNumber?: InputMaybe<InnerOrder>;
  worksheetId?: InputMaybe<InnerOrder>;
};

export type WorksheetPagePageNumberFilters = {
  OR?: InputMaybe<Array<WorksheetPagePageNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPagePageNumberfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionContentFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionContentfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionContentfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionFiltersOr>>;
  content?: InputMaybe<WorksheetPageQuestionContentFilters>;
  id?: InputMaybe<WorksheetPageQuestionIdFilters>;
  totalPoints?: InputMaybe<WorksheetPageQuestionTotalPointsFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageQuestionWorksheetPageVersionIdFilters>;
};

export type WorksheetPageQuestionFiltersOr = {
  content?: InputMaybe<WorksheetPageQuestionContentFilters>;
  id?: InputMaybe<WorksheetPageQuestionIdFilters>;
  totalPoints?: InputMaybe<WorksheetPageQuestionTotalPointsFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageQuestionWorksheetPageVersionIdFilters>;
};

export type WorksheetPageQuestionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionInsertInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  totalPoints: Scalars['Int']['input'];
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageQuestionItem = {
  __typename?: 'WorksheetPageQuestionItem';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionOrderBy = {
  content?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  totalPoints?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetPageQuestionSelectItem = {
  __typename?: 'WorksheetPageQuestionSelectItem';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionSelectItemMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageQuestionSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionTotalPointsFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionTotalPointsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionTotalPointsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageSelectItem = {
  __typename?: 'WorksheetPageSelectItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelation>;
  worksheet?: Maybe<WorksheetPageWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageSelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageSelectItemWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersion = {
  __typename?: 'WorksheetPageVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetPageVersionFilenameFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionFilenamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionFilenamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionFiltersOr>>;
  filename?: InputMaybe<WorksheetPageVersionFilenameFilters>;
  id?: InputMaybe<WorksheetPageVersionIdFilters>;
  version?: InputMaybe<WorksheetPageVersionVersionFilters>;
  worksheetPageId?: InputMaybe<WorksheetPageVersionWorksheetPageIdFilters>;
};

export type WorksheetPageVersionFiltersOr = {
  filename?: InputMaybe<WorksheetPageVersionFilenameFilters>;
  id?: InputMaybe<WorksheetPageVersionIdFilters>;
  version?: InputMaybe<WorksheetPageVersionVersionFilters>;
  worksheetPageId?: InputMaybe<WorksheetPageVersionWorksheetPageIdFilters>;
};

export type WorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionInsertInput = {
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetPageId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersionItem = {
  __typename?: 'WorksheetPageVersionItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionOrderBy = {
  filename?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetPageId?: InputMaybe<InnerOrder>;
};

export type WorksheetPageVersionSelectItem = {
  __typename?: 'WorksheetPageVersionSelectItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageVersionWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelation>;
};


export type WorksheetPageVersionSelectItemWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageVersionSelectItemWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageVersionSelectItemWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionWorksheetPageIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetPageIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetPageRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageVersionsRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageVersionsRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageWorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageWorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageWorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageWorksheetRelation = {
  __typename?: 'WorksheetPageWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSchoolGradeEndFilters = {
  OR?: InputMaybe<Array<WorksheetSchoolGradeEndfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeEndfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeStartFilters = {
  OR?: InputMaybe<Array<WorksheetSchoolGradeStartfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeStartfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSelectItem = {
  __typename?: 'WorksheetSelectItem';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSelectItemSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentFiltersOr>>;
  createdAt?: InputMaybe<WorksheetSetAssignmentCreatedAtFilters>;
  garageClassroomSessionId?: InputMaybe<WorksheetSetAssignmentGarageClassroomSessionIdFilters>;
  garageUserId?: InputMaybe<WorksheetSetAssignmentGarageUserIdFilters>;
  id?: InputMaybe<WorksheetSetAssignmentIdFilters>;
  isMarkingComplete?: InputMaybe<WorksheetSetAssignmentIsMarkingCompleteFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetAssignmentWorksheetSetVersionIdFilters>;
};

export type WorksheetSetAssignmentFiltersOr = {
  createdAt?: InputMaybe<WorksheetSetAssignmentCreatedAtFilters>;
  garageClassroomSessionId?: InputMaybe<WorksheetSetAssignmentGarageClassroomSessionIdFilters>;
  garageUserId?: InputMaybe<WorksheetSetAssignmentGarageUserIdFilters>;
  id?: InputMaybe<WorksheetSetAssignmentIdFilters>;
  isMarkingComplete?: InputMaybe<WorksheetSetAssignmentIsMarkingCompleteFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetAssignmentWorksheetSetVersionIdFilters>;
};

export type WorksheetSetAssignmentGarageClassroomSessionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentGarageClassroomSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageClassroomSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageUserIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentGarageUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isMarkingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetAssignmentIsMarkingCompleteFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentIsMarkingCompletefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIsMarkingCompletefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentItem = {
  __typename?: 'WorksheetSetAssignmentItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  garageClassroomSessionId?: InputMaybe<InnerOrder>;
  garageUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isMarkingComplete?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetAssignmentSelectItem = {
  __typename?: 'WorksheetSetAssignmentSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetAssignmentUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  garageClassroomSessionId?: InputMaybe<Scalars['Int']['input']>;
  garageUserId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMarkingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetDescriptionFilters = {
  OR?: InputMaybe<Array<WorksheetSetDescriptionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetDescriptionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetDetail = {
  __typename?: 'WorksheetSetDetail';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  versions?: Maybe<Array<Maybe<WorksheetSetVersion>>>;
};

export type WorksheetSetFilters = {
  OR?: InputMaybe<Array<WorksheetSetFiltersOr>>;
  description?: InputMaybe<WorksheetSetDescriptionFilters>;
  gaudiaLevelId?: InputMaybe<WorksheetSetGaudiaLevelIdFilters>;
  id?: InputMaybe<WorksheetSetIdFilters>;
  name?: InputMaybe<WorksheetSetNameFilters>;
  order?: InputMaybe<WorksheetSetOrderFilters>;
};

export type WorksheetSetFiltersOr = {
  description?: InputMaybe<WorksheetSetDescriptionFilters>;
  gaudiaLevelId?: InputMaybe<WorksheetSetGaudiaLevelIdFilters>;
  id?: InputMaybe<WorksheetSetIdFilters>;
  name?: InputMaybe<WorksheetSetNameFilters>;
  order?: InputMaybe<WorksheetSetOrderFilters>;
};

export type WorksheetSetGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetInsertInput = {
  description: Scalars['String']['input'];
  gaudiaLevelId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type WorksheetSetItem = {
  __typename?: 'WorksheetSetItem';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorksheetSetNameFilters = {
  OR?: InputMaybe<Array<WorksheetSetNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetOrderBy = {
  description?: InputMaybe<InnerOrder>;
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  order?: InputMaybe<InnerOrder>;
};

export type WorksheetSetOrderFilters = {
  OR?: InputMaybe<Array<WorksheetSetOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetSelectItem = {
  __typename?: 'WorksheetSetSelectItem';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelation>;
};


export type WorksheetSetSelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersion = {
  __typename?: 'WorksheetSetVersion';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetSetVersionAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionDetail = {
  __typename?: 'WorksheetSetVersionDetail';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheets?: Maybe<Array<Maybe<VersionWorksheetDetail>>>;
};

export type WorksheetSetVersionFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionFiltersOr>>;
  createdAt?: InputMaybe<WorksheetSetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetSetVersionIdFilters>;
  version?: InputMaybe<WorksheetSetVersionVersionFilters>;
  worksheetSetId?: InputMaybe<WorksheetSetVersionWorksheetSetIdFilters>;
};

export type WorksheetSetVersionFiltersOr = {
  createdAt?: InputMaybe<WorksheetSetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetSetVersionIdFilters>;
  version?: InputMaybe<WorksheetSetVersionVersionFilters>;
  worksheetSetId?: InputMaybe<WorksheetSetVersionWorksheetSetIdFilters>;
};

export type WorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItem = {
  __typename?: 'WorksheetSetVersionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemFiltersOr>>;
  id?: InputMaybe<WorksheetSetVersionItemIdFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetSetVersionItemFiltersOr = {
  id?: InputMaybe<WorksheetSetVersionItemIdFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetSetVersionItemIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItemItem = {
  __typename?: 'WorksheetSetVersionItemItem';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetVersionItemSelectItem = {
  __typename?: 'WorksheetSetVersionItemSelectItem';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionItemSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionItemUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetSetId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetVersionSelectItem = {
  __typename?: 'WorksheetSetVersionSelectItem';
  assignments: Array<WorksheetSetVersionAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionSelectItemAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionSelectItemWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionSelectItemWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionWorksheetSetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelation';
  assignments: Array<WorksheetSetVersionsRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionsRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionsRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionsRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionsRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSubunitIdFilters = {
  OR?: InputMaybe<Array<WorksheetSubunitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSubunitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSubunitRelation = {
  __typename?: 'WorksheetSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSubunitRelationWorksheetsRelation>;
};


export type WorksheetSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetTextIdentifierFilters = {
  OR?: InputMaybe<Array<WorksheetTextIdentifierfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetTextIdentifierfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetUpdateInput = {
  ageRangeEnd?: InputMaybe<Scalars['Int']['input']>;
  ageRangeStart?: InputMaybe<Scalars['Int']['input']>;
  bookOrder?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolGradeEnd?: InputMaybe<Scalars['String']['input']>;
  schoolGradeStart?: InputMaybe<Scalars['String']['input']>;
  subunitId?: InputMaybe<Scalars['Int']['input']>;
  textIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersion = {
  __typename?: 'WorksheetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetVersionCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetVersionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionDetail = {
  __typename?: 'WorksheetVersionDetail';
  id: Scalars['Int']['output'];
  pages?: Maybe<Array<Maybe<WorksheetVersionDetailWorksheetPageDetail>>>;
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionDetailWorksheetDetail>;
};

export type WorksheetVersionDetailBook = {
  __typename?: 'WorksheetVersionDetailBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionDetailSubunit = {
  __typename?: 'WorksheetVersionDetailSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionDetailWorksheetDetail = {
  __typename?: 'WorksheetVersionDetailWorksheetDetail';
  book?: Maybe<WorksheetVersionDetailBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<WorksheetVersionDetailWorksheetPageDetail>>>;
  subunit?: Maybe<WorksheetVersionDetailSubunit>;
};

export type WorksheetVersionDetailWorksheetPageDetail = {
  __typename?: 'WorksheetVersionDetailWorksheetPageDetail';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type WorksheetVersionFilters = {
  OR?: InputMaybe<Array<WorksheetVersionFiltersOr>>;
  createdAt?: InputMaybe<WorksheetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetVersionIdFilters>;
  version?: InputMaybe<WorksheetVersionVersionFilters>;
  worksheetId?: InputMaybe<WorksheetVersionWorksheetIdFilters>;
};

export type WorksheetVersionFiltersOr = {
  createdAt?: InputMaybe<WorksheetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetVersionIdFilters>;
  version?: InputMaybe<WorksheetVersionVersionFilters>;
  worksheetId?: InputMaybe<WorksheetVersionWorksheetIdFilters>;
};

export type WorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItem = {
  __typename?: 'WorksheetVersionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemFiltersOr>>;
  id?: InputMaybe<WorksheetVersionItemIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetVersionItemWorksheetPageVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetVersionItemFiltersOr = {
  id?: InputMaybe<WorksheetVersionItemIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetVersionItemWorksheetPageVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetVersionItemIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItemItem = {
  __typename?: 'WorksheetVersionItemItem';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetVersionItemSelectItem = {
  __typename?: 'WorksheetVersionItemSelectItem';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionItemSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetId?: InputMaybe<InnerOrder>;
};

export type WorksheetVersionSelectItem = {
  __typename?: 'WorksheetVersionSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionWorksheetVersionItemsRelation>;
};


export type WorksheetVersionSelectItemWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionSelectItemWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionSelectItemWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionWorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetRelation = {
  __typename?: 'WorksheetVersionWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type InsertWorksheetSetAssignmentMutationVariables = Exact<{
  values: WorksheetSetAssignmentInsertInput;
}>;


export type InsertWorksheetSetAssignmentMutation = { __typename?: 'Mutation', insertIntoWorksheetSetAssignmentSingle?: { __typename: 'WorksheetSetAssignmentItem', id: number, garageUserId: number, worksheetSetVersionId?: number | null, garageClassroomSessionId: number, isMarkingComplete: boolean } | null };

export type UpdateWorksheetSetAssignmentMutationVariables = Exact<{
  set: WorksheetSetAssignmentUpdateInput;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
}>;


export type UpdateWorksheetSetAssignmentMutation = { __typename?: 'Mutation', updateWorksheetSetAssignment: Array<{ __typename: 'WorksheetSetAssignmentItem', id: number, garageUserId: number, worksheetSetVersionId?: number | null, garageClassroomSessionId: number, isMarkingComplete: boolean }> };

export type UpsertMarkingSessionMutationVariables = Exact<{
  worksheetSetAssignmentId: Scalars['Int']['input'];
  markedQuestions: Array<MarkedQuestionInput> | MarkedQuestionInput;
}>;


export type UpsertMarkingSessionMutation = { __typename?: 'Mutation', upsertMarkingSession?: { __typename?: 'MarkingSessionResponse', sessionId: number } | null };

export type UpsertMarkingSessionOverrideMutationVariables = Exact<{
  markingSessionId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertMarkingSessionOverrideMutation = { __typename?: 'Mutation', upsertMarkingSessionOverride?: { __typename?: 'UpsertMarkingSessionOverride', id: number, markingSessionId: number, worksheetSetVersionId: number, worksheetVersionId: number, overrideStatus: string, remarks?: string | null, createdAt: string, updatedAt: string } | null };

export type UpsertWorksheetPageAnnotationMutationVariables = Exact<{
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  role: Scalars['String']['input'];
  drawing?: InputMaybe<Scalars['JSON']['input']>;
  textboxes?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpsertWorksheetPageAnnotationMutation = { __typename?: 'Mutation', upsertWorksheetPageAnnotation?: { __typename?: 'WorksheetPageAnnotation', id: number, worksheetPageVersionId: number, garageUserId: number, role: string, drawing?: any | null, textboxes?: any | null, updatedAt: string } | null };

export type GetAssignmentsQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
}>;


export type GetAssignmentsQuery = { __typename?: 'Query', getAssignments?: Array<{ __typename: 'Assignment', id: number, isMarkingComplete: boolean, worksheetSetVersion?: { __typename: 'AssigmentWorksheetSetVersion', id: number, version: number, worksheetSet?: { __typename: 'AssigmentWorksheetSet', id: number, name: string, description?: string | null } | null } | null } | null> | null };

export type GetAssignmentDetailQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetAssignmentDetailQuery = { __typename?: 'Query', getAssignmentDetail?: { __typename: 'AssignmentDetail', id: number, isMarkingComplete: boolean, worksheetSetVersion: { __typename: 'AssigmentDetailWorksheetSetVersion', id: number, version: number, worksheetSet: { __typename: 'AssigmenDetailtWorksheetSet', id: number, name: string } } } | null };

export type GetLastWorkedWorksheetPageQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetLastWorkedWorksheetPageQuery = { __typename?: 'Query', getLastWorkedWorksheetPage?: { __typename: 'WorkedWorksheetPage', annotationId: number, updatedAt: string, pageVersionId: number, pageId: number, pageName: string, pageNumber: number } | null };

export type GetLastWorkedWorksheetsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  dayStart: Scalars['String']['input'];
  dayEnd: Scalars['String']['input'];
}>;


export type GetLastWorkedWorksheetsQuery = { __typename?: 'Query', getLastWorkedWorksheets?: Array<{ __typename?: 'LastWorkedWorksheet', worksheetId: number, worksheetName: string, updatedAt: string, subunit?: { __typename?: 'LastWorkedWorksheetSubunit', subunitId: number, subunitName: string } | null, book?: { __typename?: 'LastWorkedWorksheetBook', bookId: number, bookName: string } | null, pages?: Array<{ __typename?: 'WorksheetPage', pageId: number, pageVersionId: number, pageName: string, pageNumber: number, filename?: string | null } | null> | null } | null> | null };

export type GetMarkingSessionOverrideQueryVariables = Exact<{
  where?: InputMaybe<MarkingSessionOverrideFilters>;
}>;


export type GetMarkingSessionOverrideQuery = { __typename?: 'Query', markingSessionOverride: Array<{ __typename?: 'MarkingSessionOverrideSelectItem', id: number, markingSessionId: number, worksheetSetVersionId?: number | null, worksheetVersionId?: number | null, overrideStatus: string, remarks?: string | null, createdAt: string, updatedAt: string }> };

export type GetMarkingSessionSummaryQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetMarkingSessionSummaryQuery = { __typename?: 'Query', getMarkingSessionSummary?: { __typename?: 'MarkingSessionSummary', id: number, createdAt: string, worksheets?: Array<{ __typename?: 'Worksheet', id: number, name: string, pages?: Array<{ __typename?: 'Page', id: number, name: string, pageNumber: number, questions?: Array<{ __typename?: 'Question', id: number, content: string, totalPoints: number, markedQuestions?: Array<{ __typename?: 'MarkedQuestion', id: number, points: number } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetMarkingSessionsQueryVariables = Exact<{
  where?: InputMaybe<MarkingSessionFilters>;
}>;


export type GetMarkingSessionsQuery = { __typename?: 'Query', markingSession: Array<{ __typename?: 'MarkingSessionSelectItem', id: number, worksheetSetAssignmentId?: number | null, createdAt: string, markedQuestions: Array<{ __typename?: 'MarkingSessionMarkedQuestionsRelation', id: number, points: number, worksheetPageQuestion?: { __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation', id: number, content: string, totalPoints: number, worksheetPageVersion?: { __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation', id: number } | null } | null }> }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'Student', id: number, name?: string | null, gender?: string | null } | { __typename?: 'Teacher', id: number, name?: string | null, email?: string | null } | null };

export type GetStaffScheduleQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStaffScheduleQuery = { __typename?: 'Query', getStaffSchedule?: Array<{ __typename: 'StaffSchedule', id: number, title: string, is_offline: boolean, day: string, start_time: string, end_time: string, teacher?: { __typename: 'Teacher', id: number, name?: string | null, email?: string | null, from?: string | null, image?: string | null } | null } | null> | null };

export type GetStudentPaginatedQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStudentPaginatedQuery = { __typename?: 'Query', getStudentPaginated?: { __typename?: 'GetStudentPaginated', result?: Array<{ __typename?: 'GetStudentPaginatedItem', parent?: { __typename?: 'Parent', id: number, name?: string | null } | null, student?: { __typename?: 'Student', id: number, name?: string | null } | null } | null> | null, pagination?: { __typename?: 'Pagination', page?: number | null, per_page?: number | null } | null } | null };

export type GetStudentsByClassroomSessionQueryVariables = Exact<{
  sessionId: Scalars['Int']['input'];
}>;


export type GetStudentsByClassroomSessionQuery = { __typename?: 'Query', getStudentsByClassroomSession?: { __typename: 'ClassroomSessionWithStudents', session?: { __typename: 'Session', id?: number | null, title?: string | null, is_offline?: boolean | null, link?: string | null, bts_id?: string | null, use_bts?: boolean | null, day?: string | null, start_timestamp?: string | null, end_timestamp?: string | null, course_id?: number | null, topic?: string | null, grade?: string | null, teacher?: { __typename: 'Teacher', id: number, name?: string | null, from?: string | null, image?: string | null } | null } | null, students?: Array<{ __typename: 'Student', id: number, name?: string | null, nickname?: string | null, is_trial?: boolean | null, active_subscription?: boolean | null } | null> | null } | null };

export type GetWorksheetDetailQueryVariables = Exact<{
  worksheetId: Scalars['Int']['input'];
}>;


export type GetWorksheetDetailQuery = { __typename?: 'Query', getWorksheetDetail?: { __typename: 'WorksheetDetail', id: number, name: string, subunit?: { __typename: 'WorksheetDetailSubunit', id: number, name: string } | null, book?: { __typename: 'WorksheetDetailBook', id: number, name: string } | null, versions?: Array<{ __typename: 'WorksheetVersion', id: number, version: number } | null> | null } | null };

export type GetWorksheetPageDetailQueryVariables = Exact<{
  worksheetPageId: Scalars['Int']['input'];
}>;


export type GetWorksheetPageDetailQuery = { __typename?: 'Query', getWorksheetPageDetail?: { __typename: 'WorksheetPageDetail', id: number, name: string, pageNumber: number, versions?: Array<{ __typename: 'WorksheetPageVersion', id: number, version: number } | null> | null } | null };

export type GetWorksheetPageVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetPageVersionFilters>;
}>;


export type GetWorksheetPageVersionQuery = { __typename?: 'Query', worksheetPageVersion: Array<{ __typename?: 'WorksheetPageVersionSelectItem', id: number, filename: string, version: number, worksheetAnswerKey?: { __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelation', id: number, versions: Array<{ __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation', id: number, filename: string, version: number }> } | null, worksheetQuestions: Array<{ __typename?: 'WorksheetPageVersionWorksheetQuestionsRelation', id: number, content: string, totalPoints: number, markedQuestions: Array<{ __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation', id: number, points: number, markingSession?: { __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation', id: number } | null }> }> }> };

export type GetWorksheetPageVersionDetailQueryVariables = Exact<{
  worksheetPageVersionId: Scalars['Int']['input'];
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId: Scalars['Int']['input'];
}>;


export type GetWorksheetPageVersionDetailQuery = { __typename?: 'Query', getWorksheetPageVersionDetail?: { __typename: 'PageVersionPage', id: number, version?: number | null, page?: { __typename: 'PageVersionPageDetail', name?: string | null, pageNumber?: number | null } | null, questions?: Array<{ __typename: 'PageVersionQuestion', id: number, content?: string | null, totalPoints?: number | null, markedQuestion?: { __typename: 'PageVersionMarkedQuestion', id: number, points?: number | null } | null } | null> | null, annotations?: { __typename: 'PageVersionAnnotations', student?: Array<{ __typename: 'PageVersionAnnotation', id: number, drawing?: Array<{ __typename: 'PageVersionDrawing', stroke?: number | null, color?: string | null, mode?: number | null, path?: Array<Array<number | null> | null> | null } | null> | null, textboxes?: Array<{ __typename: 'PageVersionTextbox', text?: string | null, fontSize?: number | null, position?: { __typename: 'PageVersionTextboxPosition', x?: number | null, y?: number | null } | null } | null> | null } | null> | null, teacher?: Array<{ __typename: 'PageVersionAnnotation', id: number, drawing?: Array<{ __typename: 'PageVersionDrawing', stroke?: number | null, color?: string | null, mode?: number | null, path?: Array<Array<number | null> | null> | null } | null> | null, textboxes?: Array<{ __typename: 'PageVersionTextbox', text?: string | null, fontSize?: number | null, position?: { __typename: 'PageVersionTextboxPosition', x?: number | null, y?: number | null } | null } | null> | null } | null> | null } | null, answerKey?: { __typename: 'PageVersionAnswerKey', id: number, versionId?: number | null, filename?: string | null } | null } | null };

export type GetWorksheetSetAssigmentQueryVariables = Exact<{
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
}>;


export type GetWorksheetSetAssigmentQuery = { __typename?: 'Query', worksheetSetAssignment: Array<{ __typename: 'WorksheetSetAssignmentSelectItem', id: number, garageUserId: number, garageClassroomSessionId: number, isMarkingComplete: boolean, createdAt: string, worksheetSetVersion?: { __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelation', id: number, version: number, worksheetSet?: { __typename: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation', id: number, name: string, order: number, description: string } | null, worksheetSetVersionItems: Array<{ __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation', id: number, worksheetSetVersionId?: number | null, worksheetVersionId?: number | null }> } | null }> };

export type GetWorksheetSetDetailQueryVariables = Exact<{
  worksheetSetId: Scalars['Int']['input'];
}>;


export type GetWorksheetSetDetailQuery = { __typename?: 'Query', getWorksheetSetDetail?: { __typename: 'WorksheetSetDetail', id: number, name: string, versions?: Array<{ __typename: 'WorksheetSetVersion', id: number, version: number, createdAt: string } | null> | null } | null };

export type GetWorksheetSetVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetSetVersionFilters>;
}>;


export type GetWorksheetSetVersionQuery = { __typename?: 'Query', worksheetSetVersion: Array<{ __typename?: 'WorksheetSetVersionSelectItem', id: number, version: number, assignments: Array<{ __typename?: 'WorksheetSetVersionAssignmentsRelation', garageClassroomSessionId: number }>, worksheetSet?: { __typename?: 'WorksheetSetVersionWorksheetSetRelation', id: number, name: string, order: number, versions: Array<{ __typename?: 'WorksheetSetVersionWorksheetSetRelationVersionsRelation', id: number, version: number, worksheetSetId?: number | null }> } | null, worksheetSetVersionItems: Array<{ __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelation', id: number, worksheetVersion?: { __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation', id: number, version: number, worksheet?: { __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation', id: number, name: string, bookOrder: number } | null } | null }> }> };

export type GetWorksheetSetVersionDetailQueryVariables = Exact<{
  worksheetSetId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetWorksheetSetVersionDetailQuery = { __typename?: 'Query', getWorksheetSetVersionDetail?: { __typename: 'WorksheetSetVersionDetail', id: number, version: number, createdAt: string, worksheets?: Array<{ __typename: 'VersionWorksheetDetail', id: number, name: string, version: number, versionId: number, subunit?: { __typename: 'SetVersionSubunit', id: number, name: string } | null, book?: { __typename: 'SetVersionBook', id: number, name: string } | null, pages?: Array<{ __typename: 'VersionWorksheetPageDetail', id: number, versionId: number, name: string, pageNumber: number, version: number, filename: string, questions?: Array<{ __typename: 'VersionWorksheetPageQuestion', id: number, content: string, totalPoints: number } | null> | null } | null> | null } | null> | null } | null };

export type GetWorksheetSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorksheetSetsQuery = { __typename?: 'Query', worksheetSet: Array<{ __typename: 'WorksheetSetSelectItem', id: number, name: string, description: string, gaudiaLevelId: number, order: number, versions: Array<{ __typename: 'WorksheetSetVersionsRelation', id: number, version: number, createdAt: string, worksheetSetVersionItems: Array<{ __typename: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation', id: number, worksheetVersion?: { __typename: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation', id: number, version: number, worksheetId?: number | null } | null }> }> }> };

export type GetWorksheetVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetVersionFilters>;
}>;


export type GetWorksheetVersionQuery = { __typename?: 'Query', worksheetVersion: Array<{ __typename?: 'WorksheetVersionSelectItem', id: number, worksheet?: { __typename?: 'WorksheetVersionWorksheetRelation', id: number, name: string, bookOrder: number } | null, worksheetVersionItems: Array<{ __typename?: 'WorksheetVersionWorksheetVersionItemsRelation', id: number, worksheetPageVersionId?: number | null, worksheetVersionId?: number | null, worksheetPageVersion?: { __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation', id: number, version: number, filename: string, worksheetPage?: { __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation', id: number, name: string, pageNumber: number } | null } | null }> }> };

export type GetWorksheetVersionDetailQueryVariables = Exact<{
  worksheetId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
}>;


export type GetWorksheetVersionDetailQuery = { __typename?: 'Query', getWorksheetVersionDetail?: { __typename: 'WorksheetVersionDetail', id: number, version: number, worksheet?: { __typename: 'WorksheetVersionDetailWorksheetDetail', id: number, name: string, subunit?: { __typename: 'WorksheetVersionDetailSubunit', id: number, name: string } | null, book?: { __typename: 'WorksheetVersionDetailBook', id: number, name: string } | null } | null, pages?: Array<{ __typename: 'WorksheetVersionDetailWorksheetPageDetail', id: number, name: string, pageNumber: number, version: number, versionId: number, filename: string } | null> | null } | null };


export const InsertWorksheetSetAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertWorksheetSetAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetSetAssignmentInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntoWorksheetSetAssignmentSingle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"garageUserId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"garageClassroomSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"isMarkingComplete"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<InsertWorksheetSetAssignmentMutation, InsertWorksheetSetAssignmentMutationVariables>;
export const UpdateWorksheetSetAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWorksheetSetAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetSetAssignmentUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetSetAssignmentFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorksheetSetAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"garageUserId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"garageClassroomSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"isMarkingComplete"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateWorksheetSetAssignmentMutation, UpdateWorksheetSetAssignmentMutationVariables>;
export const UpsertMarkingSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertMarkingSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markedQuestions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkedQuestionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertMarkingSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetAssignmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"markedQuestions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markedQuestions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]} as unknown as DocumentNode<UpsertMarkingSessionMutation, UpsertMarkingSessionMutationVariables>;
export const UpsertMarkingSessionOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertMarkingSessionOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markingSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overrideStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertMarkingSessionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markingSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"overrideStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overrideStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"remarks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markingSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"overrideStatus"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertMarkingSessionOverrideMutation, UpsertMarkingSessionOverrideMutationVariables>;
export const UpsertWorksheetPageAnnotationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertWorksheetPageAnnotation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"drawing"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textboxes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertWorksheetPageAnnotation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetPageVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetAssignmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"garageUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"drawing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"drawing"}}},{"kind":"Argument","name":{"kind":"Name","value":"textboxes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textboxes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPageVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"garageUserId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"drawing"}},{"kind":"Field","name":{"kind":"Name","value":"textboxes"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertWorksheetPageAnnotationMutation, UpsertWorksheetPageAnnotationMutationVariables>;
export const GetAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"garageClassroomSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"garageUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMarkingComplete"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentsQuery, GetAssignmentsQueryVariables>;
export const GetAssignmentDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssignmentDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssignmentDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"garageClassroomSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"garageUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMarkingComplete"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentDetailQuery, GetAssignmentDetailQueryVariables>;
export const GetLastWorkedWorksheetPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLastWorkedWorksheetPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLastWorkedWorksheetPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annotationId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"pageVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"pageName"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetLastWorkedWorksheetPageQuery, GetLastWorkedWorksheetPageQueryVariables>;
export const GetLastWorkedWorksheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLastWorkedWorksheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLastWorkedWorksheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayEnd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetName"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunitId"}},{"kind":"Field","name":{"kind":"Name","value":"subunitName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookId"}},{"kind":"Field","name":{"kind":"Name","value":"bookName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"pageVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"pageName"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetLastWorkedWorksheetsQuery, GetLastWorkedWorksheetsQueryVariables>;
export const GetMarkingSessionOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarkingSessionOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkingSessionOverrideFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markingSessionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markingSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"overrideStatus"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetMarkingSessionOverrideQuery, GetMarkingSessionOverrideQueryVariables>;
export const GetMarkingSessionSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarkingSessionSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMarkingSessionSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"garageClassroomSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageClassroomSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"garageUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"garageUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"worksheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"markedQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMarkingSessionSummaryQuery, GetMarkingSessionSummaryQueryVariables>;
export const GetMarkingSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarkingSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkingSessionFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markingSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetAssignmentId"}},{"kind":"Field","name":{"kind":"Name","value":"markedQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPageQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPageVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMarkingSessionsQuery, GetMarkingSessionsQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Teacher"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const GetStaffScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStaffSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStaffSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"is_offline"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetStaffScheduleQuery, GetStaffScheduleQueryVariables>;
export const GetStudentPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStudentPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStudentPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"per_page"}}]}}]}}]}}]} as unknown as DocumentNode<GetStudentPaginatedQuery, GetStudentPaginatedQueryVariables>;
export const GetStudentsByClassroomSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStudentsByClassroomSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStudentsByClassroomSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"is_offline"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"bts_id"}},{"kind":"Field","name":{"kind":"Name","value":"use_bts"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"start_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"course_id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"is_trial"}},{"kind":"Field","name":{"kind":"Name","value":"active_subscription"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetStudentsByClassroomSessionQuery, GetStudentsByClassroomSessionQueryVariables>;
export const GetWorksheetDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetDetailQuery, GetWorksheetDetailQueryVariables>;
export const GetWorksheetPageDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetPageDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetPageDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetPageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetPageDetailQuery, GetWorksheetPageDetailQueryVariables>;
export const GetWorksheetPageVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetPageVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetPageVersionFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetPageVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetAnswerKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"worksheetQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"markedQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"markingSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorksheetPageVersionQuery, GetWorksheetPageVersionQueryVariables>;
export const GetWorksheetPageVersionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetPageVersionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markingSessionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetPageVersionDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetPageVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetPageVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"markingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markingSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetAssignmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetAssignmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"markedQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"drawing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stroke"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textboxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"drawing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stroke"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textboxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"answerKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetPageVersionDetailQuery, GetWorksheetPageVersionDetailQueryVariables>;
export const GetWorksheetSetAssigmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetSetAssigment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetSetAssignmentFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetSetAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"garageUserId"}},{"kind":"Field","name":{"kind":"Name","value":"garageClassroomSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"isMarkingComplete"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersionId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetSetAssigmentQuery, GetWorksheetSetAssigmentQueryVariables>;
export const GetWorksheetSetDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetSetDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetSetDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetSetDetailQuery, GetWorksheetSetDetailQueryVariables>;
export const GetWorksheetSetVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetSetVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetSetVersionFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"garageClassroomSessionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bookOrder"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorksheetSetVersionQuery, GetWorksheetSetVersionQueryVariables>;
export const GetWorksheetSetVersionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetSetVersionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetSetVersionDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetSetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetSetVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"worksheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetSetVersionDetailQuery, GetWorksheetSetVersionDetailQueryVariables>;
export const GetWorksheetSetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"gaudiaLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetSetVersionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetId"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetSetsQuery, GetWorksheetSetsQueryVariables>;
export const GetWorksheetVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorksheetVersionFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"worksheetVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bookOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPageVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPageVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheetPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorksheetVersionQuery, GetWorksheetVersionQueryVariables>;
export const GetWorksheetVersionDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorksheetVersionDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worksheetVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorksheetVersionDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"worksheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worksheetVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worksheetVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"worksheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorksheetVersionDetailQuery, GetWorksheetVersionDetailQueryVariables>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AssigmenDetailtWorksheetSet = {
  __typename?: 'AssigmenDetailtWorksheetSet';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssigmentDetailWorksheetSetVersion = {
  __typename?: 'AssigmentDetailWorksheetSetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet: AssigmenDetailtWorksheetSet;
};

export type AssigmentWorksheetSet = {
  __typename?: 'AssigmentWorksheetSet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssigmentWorksheetSetVersion = {
  __typename?: 'AssigmentWorksheetSetVersion';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<AssigmentWorksheetSet>;
};

export type Assignment = {
  __typename?: 'Assignment';
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<AssigmentWorksheetSetVersion>;
};

export type AssignmentDetail = {
  __typename?: 'AssignmentDetail';
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion: AssigmentDetailWorksheetSetVersion;
};

export type BookFilters = {
  OR?: InputMaybe<Array<BookFiltersOr>>;
  gaudiaLevelId?: InputMaybe<BookGaudiaLevelIdFilters>;
  id?: InputMaybe<BookIdFilters>;
  name?: InputMaybe<BookNameFilters>;
};

export type BookFiltersOr = {
  gaudiaLevelId?: InputMaybe<BookGaudiaLevelIdFilters>;
  id?: InputMaybe<BookIdFilters>;
  name?: InputMaybe<BookNameFilters>;
};

export type BookGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<BookGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookGaudiaLevelRelation = {
  __typename?: 'BookGaudiaLevelRelation';
  books: Array<BookGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<BookGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type BookGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type BookGaudiaLevelRelationBooksRelation = {
  __typename?: 'BookGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'BookGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'BookGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookIdFilters = {
  OR?: InputMaybe<Array<BookIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookInsertInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type BookItem = {
  __typename?: 'BookItem';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookNameFilters = {
  OR?: InputMaybe<Array<BookNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BookOrderBy = {
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type BookSelectItem = {
  __typename?: 'BookSelectItem';
  gaudiaLevel?: Maybe<BookGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<BookUnitsRelation>;
};


export type BookSelectItemGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type BookSelectItemUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type BookUnitsRelation = {
  __typename?: 'BookUnitsRelation';
  book?: Maybe<BookUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<BookUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<BookUnitsRelationSubunitsRelation>;
};


export type BookUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type BookUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type BookUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type BookUnitsRelationBookRelation = {
  __typename?: 'BookUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationEdukitaLevelRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'BookUnitsRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationSubunitsRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<BookUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<BookUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type BookUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type BookUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type BookUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BookUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'BookUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type BookUpdateInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomSessionWithStudents = {
  __typename?: 'ClassroomSessionWithStudents';
  session?: Maybe<Session>;
  students?: Maybe<Array<Maybe<Student>>>;
};

export type EdukitaLevelFilters = {
  OR?: InputMaybe<Array<EdukitaLevelFiltersOr>>;
  gaudiaLevelId?: InputMaybe<EdukitaLevelGaudiaLevelIdFilters>;
  id?: InputMaybe<EdukitaLevelIdFilters>;
  name?: InputMaybe<EdukitaLevelNameFilters>;
};

export type EdukitaLevelFiltersOr = {
  gaudiaLevelId?: InputMaybe<EdukitaLevelGaudiaLevelIdFilters>;
  id?: InputMaybe<EdukitaLevelIdFilters>;
  name?: InputMaybe<EdukitaLevelNameFilters>;
};

export type EdukitaLevelGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<EdukitaLevelGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelGaudiaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelation';
  books: Array<EdukitaLevelGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EdukitaLevelGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type EdukitaLevelGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelation';
  book?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationEdukitaLevelRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'EdukitaLevelGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelIdFilters = {
  OR?: InputMaybe<Array<EdukitaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelInsertInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type EdukitaLevelItem = {
  __typename?: 'EdukitaLevelItem';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EdukitaLevelNameFilters = {
  OR?: InputMaybe<Array<EdukitaLevelNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type EdukitaLevelOrderBy = {
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type EdukitaLevelSelectItem = {
  __typename?: 'EdukitaLevelSelectItem';
  gaudiaLevel?: Maybe<EdukitaLevelGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EdukitaLevelSelectItemGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type EdukitaLevelUpdateInput = {
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelBooksRelation = {
  __typename?: 'GaudiaLevelBooksRelation';
  gaudiaLevel?: Maybe<GaudiaLevelBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<GaudiaLevelBooksRelationUnitsRelation>;
};


export type GaudiaLevelBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type GaudiaLevelBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type GaudiaLevelBooksRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelation';
  book?: Maybe<GaudiaLevelBooksRelationUnitsRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<GaudiaLevelBooksRelationUnitsRelationSubunitsRelation>;
};


export type GaudiaLevelBooksRelationUnitsRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationBookRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationBookRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationEdukitaLevelRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'GaudiaLevelBooksRelationUnitsRelationSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type GaudiaLevelEdukitaLevelsRelation = {
  __typename?: 'GaudiaLevelEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'GaudiaLevelEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelFilters = {
  OR?: InputMaybe<Array<GaudiaLevelFiltersOr>>;
  id?: InputMaybe<GaudiaLevelIdFilters>;
  name?: InputMaybe<GaudiaLevelNameFilters>;
};

export type GaudiaLevelFiltersOr = {
  id?: InputMaybe<GaudiaLevelIdFilters>;
  name?: InputMaybe<GaudiaLevelNameFilters>;
};

export type GaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<GaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GaudiaLevelItem = {
  __typename?: 'GaudiaLevelItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GaudiaLevelNameFilters = {
  OR?: InputMaybe<Array<GaudiaLevelNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type GaudiaLevelOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type GaudiaLevelSelectItem = {
  __typename?: 'GaudiaLevelSelectItem';
  books: Array<GaudiaLevelBooksRelation>;
  edukitaLevels: Array<GaudiaLevelEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GaudiaLevelSelectItemBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type GaudiaLevelSelectItemEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type GaudiaLevelUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetStudentPaginated = {
  __typename?: 'GetStudentPaginated';
  pagination?: Maybe<Pagination>;
  result?: Maybe<Array<Maybe<GetStudentPaginatedItem>>>;
};

export type GetStudentPaginatedItem = {
  __typename?: 'GetStudentPaginatedItem';
  parent?: Maybe<Parent>;
  student?: Maybe<Student>;
};

export type InnerOrder = {
  direction: OrderDirection;
  /** Priority of current field */
  priority: Scalars['Int']['input'];
};

export type LastWorkedWorksheet = {
  __typename?: 'LastWorkedWorksheet';
  book?: Maybe<LastWorkedWorksheetBook>;
  pages?: Maybe<Array<Maybe<WorksheetPage>>>;
  subunit?: Maybe<LastWorkedWorksheetSubunit>;
  updatedAt: Scalars['String']['output'];
  worksheetId: Scalars['Int']['output'];
  worksheetName: Scalars['String']['output'];
};

export type LastWorkedWorksheetBook = {
  __typename?: 'LastWorkedWorksheetBook';
  bookId: Scalars['Int']['output'];
  bookName: Scalars['String']['output'];
};

export type LastWorkedWorksheetSubunit = {
  __typename?: 'LastWorkedWorksheetSubunit';
  subunitId: Scalars['Int']['output'];
  subunitName: Scalars['String']['output'];
};

export type MarkedQuestion = {
  __typename?: 'MarkedQuestion';
  id: Scalars['Int']['output'];
  points: Scalars['Float']['output'];
};

export type MarkedQuestionFilters = {
  OR?: InputMaybe<Array<MarkedQuestionFiltersOr>>;
  id?: InputMaybe<MarkedQuestionIdFilters>;
  markingSessionId?: InputMaybe<MarkedQuestionMarkingSessionIdFilters>;
  points?: InputMaybe<MarkedQuestionPointsFilters>;
  worksheetPageQuestionId?: InputMaybe<MarkedQuestionWorksheetPageQuestionIdFilters>;
};

export type MarkedQuestionFiltersOr = {
  id?: InputMaybe<MarkedQuestionIdFilters>;
  markingSessionId?: InputMaybe<MarkedQuestionMarkingSessionIdFilters>;
  points?: InputMaybe<MarkedQuestionPointsFilters>;
  worksheetPageQuestionId?: InputMaybe<MarkedQuestionWorksheetPageQuestionIdFilters>;
};

export type MarkedQuestionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionInput = {
  points: Scalars['Int']['input'];
  worksheetPageQuestionId: Scalars['Int']['input'];
};

export type MarkedQuestionInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  points: Scalars['Int']['input'];
  worksheetPageQuestionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkedQuestionItem = {
  __typename?: 'MarkedQuestionItem';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionMarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionMarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionMarkingSessionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkedQuestionMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionOrderBy = {
  id?: InputMaybe<InnerOrder>;
  markingSessionId?: InputMaybe<InnerOrder>;
  points?: InputMaybe<InnerOrder>;
  worksheetPageQuestionId?: InputMaybe<InnerOrder>;
};

export type MarkedQuestionPointsFilters = {
  OR?: InputMaybe<Array<MarkedQuestionPointsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionPointsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionSelectItem = {
  __typename?: 'MarkedQuestionSelectItem';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkedQuestionMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkedQuestionWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionSelectItemMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkedQuestionSelectItemWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageQuestionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionIdFilters = {
  OR?: InputMaybe<Array<MarkedQuestionWorksheetPageQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedQuestionWorksheetPageQuestionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkedQuestionWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionCreatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionFilters = {
  OR?: InputMaybe<Array<MarkingSessionFiltersOr>>;
  createdAt?: InputMaybe<MarkingSessionCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<MarkingSessionWorksheetSetAssignmentIdFilters>;
};

export type MarkingSessionFiltersOr = {
  createdAt?: InputMaybe<MarkingSessionCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<MarkingSessionWorksheetSetAssignmentIdFilters>;
};

export type MarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionItem = {
  __typename?: 'MarkingSessionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  worksheetSetAssignmentId?: InputMaybe<InnerOrder>;
};

export type MarkingSessionOverrideCreatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideFiltersOr>>;
  createdAt?: InputMaybe<MarkingSessionOverrideCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionOverrideIdFilters>;
  markingSessionId?: InputMaybe<MarkingSessionOverrideMarkingSessionIdFilters>;
  overrideStatus?: InputMaybe<MarkingSessionOverrideOverrideStatusFilters>;
  remarks?: InputMaybe<MarkingSessionOverrideRemarksFilters>;
  updatedAt?: InputMaybe<MarkingSessionOverrideUpdatedAtFilters>;
  worksheetSetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetVersionIdFilters>;
};

export type MarkingSessionOverrideFiltersOr = {
  createdAt?: InputMaybe<MarkingSessionOverrideCreatedAtFilters>;
  id?: InputMaybe<MarkingSessionOverrideIdFilters>;
  markingSessionId?: InputMaybe<MarkingSessionOverrideMarkingSessionIdFilters>;
  overrideStatus?: InputMaybe<MarkingSessionOverrideOverrideStatusFilters>;
  remarks?: InputMaybe<MarkingSessionOverrideRemarksFilters>;
  updatedAt?: InputMaybe<MarkingSessionOverrideUpdatedAtFilters>;
  worksheetSetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<MarkingSessionOverrideWorksheetVersionIdFilters>;
};

export type MarkingSessionOverrideIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionOverrideItem = {
  __typename?: 'MarkingSessionOverrideItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideMarkingSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideMarkingSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  markingSessionId?: InputMaybe<InnerOrder>;
  overrideStatus?: InputMaybe<InnerOrder>;
  remarks?: InputMaybe<InnerOrder>;
  updatedAt?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type MarkingSessionOverrideOverrideStatusFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideOverrideStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideOverrideStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideRemarksFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideRemarksfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideRemarksfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideSelectItem = {
  __typename?: 'MarkingSessionOverrideSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideMarkingSessionRelation>;
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideSelectItemMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  overrideStatus?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionOverrideUpdatedAtFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideUpdatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideUpdatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionOverrideWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionOverrideWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionOverrideWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionResponse = {
  __typename?: 'MarkingSessionResponse';
  sessionId: Scalars['Int']['output'];
};

export type MarkingSessionSelectItem = {
  __typename?: 'MarkingSessionSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<MarkingSessionWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionSelectItemMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionSelectItemWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type MarkingSessionSummary = {
  __typename?: 'MarkingSessionSummary';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheets?: Maybe<Array<Maybe<Worksheet>>>;
};

export type MarkingSessionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<MarkingSessionWorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MarkingSessionWorksheetSetAssignmentRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'MarkingSessionWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteFromBook: Array<BookItem>;
  deleteFromEdukitaLevel: Array<EdukitaLevelItem>;
  deleteFromGaudiaLevel: Array<GaudiaLevelItem>;
  deleteFromMarkedQuestion: Array<MarkedQuestionItem>;
  deleteFromMarkingSession: Array<MarkingSessionItem>;
  deleteFromMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  deleteFromSubunit: Array<SubunitItem>;
  deleteFromUnit: Array<UnitItem>;
  deleteFromWorksheet: Array<WorksheetItem>;
  deleteFromWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  deleteFromWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  deleteFromWorksheetPage: Array<WorksheetPageItem>;
  deleteFromWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  deleteFromWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  deleteFromWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  deleteFromWorksheetSet: Array<WorksheetSetItem>;
  deleteFromWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  deleteFromWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  deleteFromWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  deleteFromWorksheetVersion: Array<WorksheetVersionItem>;
  deleteFromWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  insertIntoBook: Array<BookItem>;
  insertIntoBookSingle?: Maybe<BookItem>;
  insertIntoEdukitaLevel: Array<EdukitaLevelItem>;
  insertIntoEdukitaLevelSingle?: Maybe<EdukitaLevelItem>;
  insertIntoGaudiaLevel: Array<GaudiaLevelItem>;
  insertIntoGaudiaLevelSingle?: Maybe<GaudiaLevelItem>;
  insertIntoMarkedQuestion: Array<MarkedQuestionItem>;
  insertIntoMarkedQuestionSingle?: Maybe<MarkedQuestionItem>;
  insertIntoMarkingSession: Array<MarkingSessionItem>;
  insertIntoMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  insertIntoMarkingSessionOverrideSingle?: Maybe<MarkingSessionOverrideItem>;
  insertIntoMarkingSessionSingle?: Maybe<MarkingSessionItem>;
  insertIntoSubunit: Array<SubunitItem>;
  insertIntoSubunitSingle?: Maybe<SubunitItem>;
  insertIntoUnit: Array<UnitItem>;
  insertIntoUnitSingle?: Maybe<UnitItem>;
  insertIntoWorksheet: Array<WorksheetItem>;
  insertIntoWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  insertIntoWorksheetAnswerKeySingle?: Maybe<WorksheetAnswerKeyItem>;
  insertIntoWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  insertIntoWorksheetAnswerKeyVersionSingle?: Maybe<WorksheetAnswerKeyVersionItem>;
  insertIntoWorksheetPage: Array<WorksheetPageItem>;
  insertIntoWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  insertIntoWorksheetPageAnnotationSingle?: Maybe<WorksheetPageAnnotationItem>;
  insertIntoWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  insertIntoWorksheetPageQuestionSingle?: Maybe<WorksheetPageQuestionItem>;
  insertIntoWorksheetPageSingle?: Maybe<WorksheetPageItem>;
  insertIntoWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  insertIntoWorksheetPageVersionSingle?: Maybe<WorksheetPageVersionItem>;
  insertIntoWorksheetSet: Array<WorksheetSetItem>;
  insertIntoWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  insertIntoWorksheetSetAssignmentSingle?: Maybe<WorksheetSetAssignmentItem>;
  insertIntoWorksheetSetSingle?: Maybe<WorksheetSetItem>;
  insertIntoWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  insertIntoWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  insertIntoWorksheetSetVersionItemSingle?: Maybe<WorksheetSetVersionItemItem>;
  insertIntoWorksheetSetVersionSingle?: Maybe<WorksheetSetVersionItem>;
  insertIntoWorksheetSingle?: Maybe<WorksheetItem>;
  insertIntoWorksheetVersion: Array<WorksheetVersionItem>;
  insertIntoWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  insertIntoWorksheetVersionItemSingle?: Maybe<WorksheetVersionItemItem>;
  insertIntoWorksheetVersionSingle?: Maybe<WorksheetVersionItem>;
  updateBook: Array<BookItem>;
  updateEdukitaLevel: Array<EdukitaLevelItem>;
  updateGaudiaLevel: Array<GaudiaLevelItem>;
  updateMarkedQuestion: Array<MarkedQuestionItem>;
  updateMarkingSession: Array<MarkingSessionItem>;
  updateMarkingSessionOverride: Array<MarkingSessionOverrideItem>;
  updateSubunit: Array<SubunitItem>;
  updateUnit: Array<UnitItem>;
  updateWorksheet: Array<WorksheetItem>;
  updateWorksheetAnswerKey: Array<WorksheetAnswerKeyItem>;
  updateWorksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionItem>;
  updateWorksheetPage: Array<WorksheetPageItem>;
  updateWorksheetPageAnnotation: Array<WorksheetPageAnnotationItem>;
  updateWorksheetPageQuestion: Array<WorksheetPageQuestionItem>;
  updateWorksheetPageVersion: Array<WorksheetPageVersionItem>;
  updateWorksheetSet: Array<WorksheetSetItem>;
  updateWorksheetSetAssignment: Array<WorksheetSetAssignmentItem>;
  updateWorksheetSetVersion: Array<WorksheetSetVersionItem>;
  updateWorksheetSetVersionItem: Array<WorksheetSetVersionItemItem>;
  updateWorksheetVersion: Array<WorksheetVersionItem>;
  updateWorksheetVersionItem: Array<WorksheetVersionItemItem>;
  upsertMarkingSession?: Maybe<MarkingSessionResponse>;
  upsertMarkingSessionOverride?: Maybe<UpsertMarkingSessionOverride>;
  upsertWorksheetPageAnnotation?: Maybe<WorksheetPageAnnotation>;
};


export type MutationDeleteFromBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type MutationDeleteFromEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MutationDeleteFromGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MutationDeleteFromMarkedQuestionArgs = {
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MutationDeleteFromMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MutationDeleteFromMarkingSessionOverrideArgs = {
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type MutationDeleteFromSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};


export type MutationDeleteFromUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MutationDeleteFromWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type MutationDeleteFromWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MutationDeleteFromWorksheetAnswerKeyVersionArgs = {
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MutationDeleteFromWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MutationDeleteFromWorksheetPageAnnotationArgs = {
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type MutationDeleteFromWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type MutationDeleteFromWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MutationDeleteFromWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MutationDeleteFromWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MutationDeleteFromWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MutationDeleteFromWorksheetSetVersionItemArgs = {
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MutationDeleteFromWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type MutationDeleteFromWorksheetVersionItemArgs = {
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type MutationInsertIntoBookArgs = {
  values: Array<BookInsertInput>;
};


export type MutationInsertIntoBookSingleArgs = {
  values: BookInsertInput;
};


export type MutationInsertIntoEdukitaLevelArgs = {
  values: Array<EdukitaLevelInsertInput>;
};


export type MutationInsertIntoEdukitaLevelSingleArgs = {
  values: EdukitaLevelInsertInput;
};


export type MutationInsertIntoGaudiaLevelArgs = {
  values: Array<GaudiaLevelInsertInput>;
};


export type MutationInsertIntoGaudiaLevelSingleArgs = {
  values: GaudiaLevelInsertInput;
};


export type MutationInsertIntoMarkedQuestionArgs = {
  values: Array<MarkedQuestionInsertInput>;
};


export type MutationInsertIntoMarkedQuestionSingleArgs = {
  values: MarkedQuestionInsertInput;
};


export type MutationInsertIntoMarkingSessionArgs = {
  values: Array<MarkingSessionInsertInput>;
};


export type MutationInsertIntoMarkingSessionOverrideArgs = {
  values: Array<MarkingSessionOverrideInsertInput>;
};


export type MutationInsertIntoMarkingSessionOverrideSingleArgs = {
  values: MarkingSessionOverrideInsertInput;
};


export type MutationInsertIntoMarkingSessionSingleArgs = {
  values: MarkingSessionInsertInput;
};


export type MutationInsertIntoSubunitArgs = {
  values: Array<SubunitInsertInput>;
};


export type MutationInsertIntoSubunitSingleArgs = {
  values: SubunitInsertInput;
};


export type MutationInsertIntoUnitArgs = {
  values: Array<UnitInsertInput>;
};


export type MutationInsertIntoUnitSingleArgs = {
  values: UnitInsertInput;
};


export type MutationInsertIntoWorksheetArgs = {
  values: Array<WorksheetInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeyArgs = {
  values: Array<WorksheetAnswerKeyInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeySingleArgs = {
  values: WorksheetAnswerKeyInsertInput;
};


export type MutationInsertIntoWorksheetAnswerKeyVersionArgs = {
  values: Array<WorksheetAnswerKeyVersionInsertInput>;
};


export type MutationInsertIntoWorksheetAnswerKeyVersionSingleArgs = {
  values: WorksheetAnswerKeyVersionInsertInput;
};


export type MutationInsertIntoWorksheetPageArgs = {
  values: Array<WorksheetPageInsertInput>;
};


export type MutationInsertIntoWorksheetPageAnnotationArgs = {
  values: Array<WorksheetPageAnnotationInsertInput>;
};


export type MutationInsertIntoWorksheetPageAnnotationSingleArgs = {
  values: WorksheetPageAnnotationInsertInput;
};


export type MutationInsertIntoWorksheetPageQuestionArgs = {
  values: Array<WorksheetPageQuestionInsertInput>;
};


export type MutationInsertIntoWorksheetPageQuestionSingleArgs = {
  values: WorksheetPageQuestionInsertInput;
};


export type MutationInsertIntoWorksheetPageSingleArgs = {
  values: WorksheetPageInsertInput;
};


export type MutationInsertIntoWorksheetPageVersionArgs = {
  values: Array<WorksheetPageVersionInsertInput>;
};


export type MutationInsertIntoWorksheetPageVersionSingleArgs = {
  values: WorksheetPageVersionInsertInput;
};


export type MutationInsertIntoWorksheetSetArgs = {
  values: Array<WorksheetSetInsertInput>;
};


export type MutationInsertIntoWorksheetSetAssignmentArgs = {
  values: Array<WorksheetSetAssignmentInsertInput>;
};


export type MutationInsertIntoWorksheetSetAssignmentSingleArgs = {
  values: WorksheetSetAssignmentInsertInput;
};


export type MutationInsertIntoWorksheetSetSingleArgs = {
  values: WorksheetSetInsertInput;
};


export type MutationInsertIntoWorksheetSetVersionArgs = {
  values: Array<WorksheetSetVersionInsertInput>;
};


export type MutationInsertIntoWorksheetSetVersionItemArgs = {
  values: Array<WorksheetSetVersionItemInsertInput>;
};


export type MutationInsertIntoWorksheetSetVersionItemSingleArgs = {
  values: WorksheetSetVersionItemInsertInput;
};


export type MutationInsertIntoWorksheetSetVersionSingleArgs = {
  values: WorksheetSetVersionInsertInput;
};


export type MutationInsertIntoWorksheetSingleArgs = {
  values: WorksheetInsertInput;
};


export type MutationInsertIntoWorksheetVersionArgs = {
  values: Array<WorksheetVersionInsertInput>;
};


export type MutationInsertIntoWorksheetVersionItemArgs = {
  values: Array<WorksheetVersionItemInsertInput>;
};


export type MutationInsertIntoWorksheetVersionItemSingleArgs = {
  values: WorksheetVersionItemInsertInput;
};


export type MutationInsertIntoWorksheetVersionSingleArgs = {
  values: WorksheetVersionInsertInput;
};


export type MutationUpdateBookArgs = {
  set: BookUpdateInput;
  where?: InputMaybe<BookFilters>;
};


export type MutationUpdateEdukitaLevelArgs = {
  set: EdukitaLevelUpdateInput;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type MutationUpdateGaudiaLevelArgs = {
  set: GaudiaLevelUpdateInput;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type MutationUpdateMarkedQuestionArgs = {
  set: MarkedQuestionUpdateInput;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type MutationUpdateMarkingSessionArgs = {
  set: MarkingSessionUpdateInput;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type MutationUpdateMarkingSessionOverrideArgs = {
  set: MarkingSessionOverrideUpdateInput;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type MutationUpdateSubunitArgs = {
  set: SubunitUpdateInput;
  where?: InputMaybe<SubunitFilters>;
};


export type MutationUpdateUnitArgs = {
  set: UnitUpdateInput;
  where?: InputMaybe<UnitFilters>;
};


export type MutationUpdateWorksheetArgs = {
  set: WorksheetUpdateInput;
  where?: InputMaybe<WorksheetFilters>;
};


export type MutationUpdateWorksheetAnswerKeyArgs = {
  set: WorksheetAnswerKeyUpdateInput;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type MutationUpdateWorksheetAnswerKeyVersionArgs = {
  set: WorksheetAnswerKeyVersionUpdateInput;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type MutationUpdateWorksheetPageArgs = {
  set: WorksheetPageUpdateInput;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type MutationUpdateWorksheetPageAnnotationArgs = {
  set: WorksheetPageAnnotationUpdateInput;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type MutationUpdateWorksheetPageQuestionArgs = {
  set: WorksheetPageQuestionUpdateInput;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type MutationUpdateWorksheetPageVersionArgs = {
  set: WorksheetPageVersionUpdateInput;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type MutationUpdateWorksheetSetArgs = {
  set: WorksheetSetUpdateInput;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type MutationUpdateWorksheetSetAssignmentArgs = {
  set: WorksheetSetAssignmentUpdateInput;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type MutationUpdateWorksheetSetVersionArgs = {
  set: WorksheetSetVersionUpdateInput;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type MutationUpdateWorksheetSetVersionItemArgs = {
  set: WorksheetSetVersionItemUpdateInput;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type MutationUpdateWorksheetVersionArgs = {
  set: WorksheetVersionUpdateInput;
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type MutationUpdateWorksheetVersionItemArgs = {
  set: WorksheetVersionItemUpdateInput;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type MutationUpsertMarkingSessionArgs = {
  markedQuestions: Array<InputMaybe<MarkedQuestionInput>>;
  worksheetSetAssignmentId: Scalars['Int']['input'];
};


export type MutationUpsertMarkingSessionOverrideArgs = {
  markingSessionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  worksheetSetVersionId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
};


export type MutationUpsertWorksheetPageAnnotationArgs = {
  drawing?: InputMaybe<Scalars['JSON']['input']>;
  garageUserId: Scalars['Int']['input'];
  role: Scalars['String']['input'];
  textboxes?: InputMaybe<Scalars['JSON']['input']>;
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
};

/** Order by direction */
export enum OrderDirection {
  /** Ascending order */
  Asc = 'asc',
  /** Descending order */
  Desc = 'desc'
}

export type Page = {
  __typename?: 'Page';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  questions?: Maybe<Array<Maybe<Question>>>;
};

export type PageVersionAnnotation = {
  __typename?: 'PageVersionAnnotation';
  drawing?: Maybe<Array<Maybe<PageVersionDrawing>>>;
  id: Scalars['Int']['output'];
  textboxes?: Maybe<Array<Maybe<PageVersionTextbox>>>;
};

export type PageVersionAnnotations = {
  __typename?: 'PageVersionAnnotations';
  student?: Maybe<Array<Maybe<PageVersionAnnotation>>>;
  teacher?: Maybe<Array<Maybe<PageVersionAnnotation>>>;
};

export type PageVersionAnswerKey = {
  __typename?: 'PageVersionAnswerKey';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionDrawing = {
  __typename?: 'PageVersionDrawing';
  color?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  stroke?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionMarkedQuestion = {
  __typename?: 'PageVersionMarkedQuestion';
  id: Scalars['Int']['output'];
  points?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionPage = {
  __typename?: 'PageVersionPage';
  annotations?: Maybe<PageVersionAnnotations>;
  answerKey?: Maybe<PageVersionAnswerKey>;
  id: Scalars['Int']['output'];
  page?: Maybe<PageVersionPageDetail>;
  questions?: Maybe<Array<Maybe<PageVersionQuestion>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionPageDetail = {
  __typename?: 'PageVersionPageDetail';
  name?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionQuestion = {
  __typename?: 'PageVersionQuestion';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  markedQuestion?: Maybe<PageVersionMarkedQuestion>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
};

export type PageVersionTextbox = {
  __typename?: 'PageVersionTextbox';
  fontSize?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<PageVersionTextboxPosition>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PageVersionTextboxPosition = {
  __typename?: 'PageVersionTextboxPosition';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  items?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  per_page?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type Parent = {
  __typename?: 'Parent';
  honorific?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registration_flow_status?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  book: Array<BookSelectItem>;
  bookSingle?: Maybe<BookSelectItem>;
  edukitaLevel: Array<EdukitaLevelSelectItem>;
  edukitaLevelSingle?: Maybe<EdukitaLevelSelectItem>;
  gaudiaLevel: Array<GaudiaLevelSelectItem>;
  gaudiaLevelSingle?: Maybe<GaudiaLevelSelectItem>;
  getAssignmentDetail?: Maybe<AssignmentDetail>;
  getAssignments?: Maybe<Array<Maybe<Assignment>>>;
  getLastWorkedWorksheetPage?: Maybe<WorkedWorksheetPage>;
  getLastWorkedWorksheets?: Maybe<Array<Maybe<LastWorkedWorksheet>>>;
  getMarkingSessionSummary?: Maybe<MarkingSessionSummary>;
  getMe?: Maybe<User>;
  getStaffSchedule?: Maybe<Array<Maybe<StaffSchedule>>>;
  getStudentPaginated?: Maybe<GetStudentPaginated>;
  getStudentsByClassroomSession?: Maybe<ClassroomSessionWithStudents>;
  getWorksheetDetail?: Maybe<WorksheetDetail>;
  getWorksheetPageDetail?: Maybe<WorksheetPageDetail>;
  getWorksheetPageVersionDetail?: Maybe<PageVersionPage>;
  getWorksheetSetDetail?: Maybe<WorksheetSetDetail>;
  getWorksheetSetVersionDetail?: Maybe<WorksheetSetVersionDetail>;
  getWorksheetVersionDetail?: Maybe<WorksheetVersionDetail>;
  markedQuestion: Array<MarkedQuestionSelectItem>;
  markedQuestionSingle?: Maybe<MarkedQuestionSelectItem>;
  markingSession: Array<MarkingSessionSelectItem>;
  markingSessionOverride: Array<MarkingSessionOverrideSelectItem>;
  markingSessionOverrideSingle?: Maybe<MarkingSessionOverrideSelectItem>;
  markingSessionSingle?: Maybe<MarkingSessionSelectItem>;
  subunit: Array<SubunitSelectItem>;
  subunitSingle?: Maybe<SubunitSelectItem>;
  unit: Array<UnitSelectItem>;
  unitSingle?: Maybe<UnitSelectItem>;
  worksheet: Array<WorksheetSelectItem>;
  worksheetAnswerKey: Array<WorksheetAnswerKeySelectItem>;
  worksheetAnswerKeySingle?: Maybe<WorksheetAnswerKeySelectItem>;
  worksheetAnswerKeyVersion: Array<WorksheetAnswerKeyVersionSelectItem>;
  worksheetAnswerKeyVersionSingle?: Maybe<WorksheetAnswerKeyVersionSelectItem>;
  worksheetPage: Array<WorksheetPageSelectItem>;
  worksheetPageAnnotation: Array<WorksheetPageAnnotationSelectItem>;
  worksheetPageAnnotationSingle?: Maybe<WorksheetPageAnnotationSelectItem>;
  worksheetPageQuestion: Array<WorksheetPageQuestionSelectItem>;
  worksheetPageQuestionSingle?: Maybe<WorksheetPageQuestionSelectItem>;
  worksheetPageSingle?: Maybe<WorksheetPageSelectItem>;
  worksheetPageVersion: Array<WorksheetPageVersionSelectItem>;
  worksheetPageVersionSingle?: Maybe<WorksheetPageVersionSelectItem>;
  worksheetSet: Array<WorksheetSetSelectItem>;
  worksheetSetAssignment: Array<WorksheetSetAssignmentSelectItem>;
  worksheetSetAssignmentSingle?: Maybe<WorksheetSetAssignmentSelectItem>;
  worksheetSetSingle?: Maybe<WorksheetSetSelectItem>;
  worksheetSetVersion: Array<WorksheetSetVersionSelectItem>;
  worksheetSetVersionItem: Array<WorksheetSetVersionItemSelectItem>;
  worksheetSetVersionItemSingle?: Maybe<WorksheetSetVersionItemSelectItem>;
  worksheetSetVersionSingle?: Maybe<WorksheetSetVersionSelectItem>;
  worksheetSingle?: Maybe<WorksheetSelectItem>;
  worksheetVersion: Array<WorksheetVersionSelectItem>;
  worksheetVersionItem: Array<WorksheetVersionItemSelectItem>;
  worksheetVersionItemSingle?: Maybe<WorksheetVersionItemSelectItem>;
  worksheetVersionSingle?: Maybe<WorksheetVersionSelectItem>;
};


export type QueryBookArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type QueryBookSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type QueryEdukitaLevelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type QueryEdukitaLevelSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type QueryGaudiaLevelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GaudiaLevelOrderBy>;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type QueryGaudiaLevelSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GaudiaLevelOrderBy>;
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type QueryGetAssignmentDetailArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetAssignmentsArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
};


export type QueryGetLastWorkedWorksheetPageArgs = {
  userId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetLastWorkedWorksheetsArgs = {
  dayEnd: Scalars['String']['input'];
  dayStart: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryGetMarkingSessionSummaryArgs = {
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetStaffScheduleArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentPaginatedArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStudentsByClassroomSessionArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QueryGetWorksheetDetailArgs = {
  worksheetId: Scalars['Int']['input'];
};


export type QueryGetWorksheetPageDetailArgs = {
  worksheetPageId: Scalars['Int']['input'];
};


export type QueryGetWorksheetPageVersionDetailArgs = {
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
};


export type QueryGetWorksheetSetDetailArgs = {
  worksheetSetId: Scalars['Int']['input'];
};


export type QueryGetWorksheetSetVersionDetailArgs = {
  worksheetSetId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
};


export type QueryGetWorksheetVersionDetailArgs = {
  worksheetId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
};


export type QueryMarkedQuestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type QueryMarkedQuestionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type QueryMarkingSessionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOrderBy>;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type QueryMarkingSessionOverrideArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOverrideOrderBy>;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type QueryMarkingSessionOverrideSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOverrideOrderBy>;
  where?: InputMaybe<MarkingSessionOverrideFilters>;
};


export type QueryMarkingSessionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkingSessionOrderBy>;
  where?: InputMaybe<MarkingSessionFilters>;
};


export type QuerySubunitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};


export type QuerySubunitSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};


export type QueryUnitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};


export type QueryUnitSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};


export type QueryWorksheetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};


export type QueryWorksheetAnswerKeyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type QueryWorksheetAnswerKeySingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type QueryWorksheetAnswerKeyVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type QueryWorksheetAnswerKeyVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type QueryWorksheetPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageOrderBy>;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type QueryWorksheetPageAnnotationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageAnnotationOrderBy>;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type QueryWorksheetPageAnnotationSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageAnnotationOrderBy>;
  where?: InputMaybe<WorksheetPageAnnotationFilters>;
};


export type QueryWorksheetPageQuestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type QueryWorksheetPageQuestionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};


export type QueryWorksheetPageSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageOrderBy>;
  where?: InputMaybe<WorksheetPageFilters>;
};


export type QueryWorksheetPageVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type QueryWorksheetPageVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type QueryWorksheetSetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetOrderBy>;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type QueryWorksheetSetAssignmentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type QueryWorksheetSetAssignmentSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type QueryWorksheetSetSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetOrderBy>;
  where?: InputMaybe<WorksheetSetFilters>;
};


export type QueryWorksheetSetVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type QueryWorksheetSetVersionItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type QueryWorksheetSetVersionItemSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type QueryWorksheetSetVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type QueryWorksheetSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};


export type QueryWorksheetVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionOrderBy>;
  where?: InputMaybe<WorksheetVersionFilters>;
};


export type QueryWorksheetVersionItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type QueryWorksheetVersionItemSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};


export type QueryWorksheetVersionSingleArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionOrderBy>;
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type Question = {
  __typename?: 'Question';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions?: Maybe<Array<Maybe<MarkedQuestion>>>;
  totalPoints: Scalars['Float']['output'];
};

export type Session = {
  __typename?: 'Session';
  bts_id?: Maybe<Scalars['String']['output']>;
  course_id?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  end_timestamp?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_offline?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  start_timestamp?: Maybe<Scalars['String']['output']>;
  teacher?: Maybe<Teacher>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  use_bts?: Maybe<Scalars['Boolean']['output']>;
};

export type SetVersionBook = {
  __typename?: 'SetVersionBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SetVersionSubunit = {
  __typename?: 'SetVersionSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StaffSchedule = {
  __typename?: 'StaffSchedule';
  day: Scalars['String']['output'];
  end_time: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_offline: Scalars['Boolean']['output'];
  start_time: Scalars['String']['output'];
  teacher?: Maybe<Teacher>;
  title: Scalars['String']['output'];
};

export type Student = {
  __typename?: 'Student';
  active_subscription?: Maybe<Scalars['Boolean']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_trial?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  package_group?: Maybe<Scalars['String']['output']>;
};

export type SubunitFilters = {
  OR?: InputMaybe<Array<SubunitFiltersOr>>;
  id?: InputMaybe<SubunitIdFilters>;
  name?: InputMaybe<SubunitNameFilters>;
  order?: InputMaybe<SubunitOrderFilters>;
  unitId?: InputMaybe<SubunitUnitIdFilters>;
};

export type SubunitFiltersOr = {
  id?: InputMaybe<SubunitIdFilters>;
  name?: InputMaybe<SubunitNameFilters>;
  order?: InputMaybe<SubunitOrderFilters>;
  unitId?: InputMaybe<SubunitUnitIdFilters>;
};

export type SubunitIdFilters = {
  OR?: InputMaybe<Array<SubunitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubunitItem = {
  __typename?: 'SubunitItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type SubunitNameFilters = {
  OR?: InputMaybe<Array<SubunitNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  order?: InputMaybe<InnerOrder>;
  unitId?: InputMaybe<InnerOrder>;
};

export type SubunitOrderFilters = {
  OR?: InputMaybe<Array<SubunitOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitSelectItem = {
  __typename?: 'SubunitSelectItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<SubunitUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<SubunitWorksheetsRelation>;
};


export type SubunitSelectItemUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type SubunitSelectItemWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type SubunitUnitIdFilters = {
  OR?: InputMaybe<Array<SubunitUnitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitUnitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubunitUnitRelation = {
  __typename?: 'SubunitUnitRelation';
  book?: Maybe<SubunitUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<SubunitUnitRelationSubunitsRelation>;
};


export type SubunitUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type SubunitUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type SubunitUnitRelationBookRelation = {
  __typename?: 'SubunitUnitRelationBookRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<SubunitUnitRelationBookRelationUnitsRelation>;
};


export type SubunitUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type SubunitUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationBookRelationUnitsRelation = {
  __typename?: 'SubunitUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'SubunitUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubunitUnitRelationSubunitsRelation = {
  __typename?: 'SubunitUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type SubunitUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubunitWorksheetsRelation = {
  __typename?: 'SubunitWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<SubunitWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type SubunitWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type SubunitWorksheetsRelationSubunitRelation = {
  __typename?: 'SubunitWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type Teacher = {
  __typename?: 'Teacher';
  email?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnitBookIdFilters = {
  OR?: InputMaybe<Array<UnitBookIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitBookIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitBookRelation = {
  __typename?: 'UnitBookRelation';
  gaudiaLevel?: Maybe<UnitBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<UnitBookRelationUnitsRelation>;
};


export type UnitBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type UnitBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type UnitBookRelationGaudiaLevelRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelation';
  books: Array<UnitBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type UnitBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'UnitBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitBookRelationUnitsRelation = {
  __typename?: 'UnitBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelIdFilters = {
  OR?: InputMaybe<Array<UnitEdukitaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitEdukitaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitEdukitaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelation';
  gaudiaLevel?: Maybe<UnitEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'UnitEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitFilters = {
  OR?: InputMaybe<Array<UnitFiltersOr>>;
  bookId?: InputMaybe<UnitBookIdFilters>;
  edukitaLevelId?: InputMaybe<UnitEdukitaLevelIdFilters>;
  id?: InputMaybe<UnitIdFilters>;
  name?: InputMaybe<UnitNameFilters>;
};

export type UnitFiltersOr = {
  bookId?: InputMaybe<UnitBookIdFilters>;
  edukitaLevelId?: InputMaybe<UnitEdukitaLevelIdFilters>;
  id?: InputMaybe<UnitIdFilters>;
  name?: InputMaybe<UnitNameFilters>;
};

export type UnitIdFilters = {
  OR?: InputMaybe<Array<UnitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitInsertInput = {
  bookId?: InputMaybe<Scalars['Int']['input']>;
  edukitaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UnitItem = {
  __typename?: 'UnitItem';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitNameFilters = {
  OR?: InputMaybe<Array<UnitNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitOrderBy = {
  bookId?: InputMaybe<InnerOrder>;
  edukitaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
};

export type UnitSelectItem = {
  __typename?: 'UnitSelectItem';
  book?: Maybe<UnitBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<UnitEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<UnitSubunitsRelation>;
};


export type UnitSelectItemBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type UnitSelectItemEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type UnitSelectItemSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type UnitSubunitsRelation = {
  __typename?: 'UnitSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<UnitSubunitsRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<UnitSubunitsRelationWorksheetsRelation>;
};


export type UnitSubunitsRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type UnitSubunitsRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type UnitSubunitsRelationUnitRelation = {
  __typename?: 'UnitSubunitsRelationUnitRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnitSubunitsRelationWorksheetsRelation = {
  __typename?: 'UnitSubunitsRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<UnitSubunitsRelationWorksheetsRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type UnitSubunitsRelationWorksheetsRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type UnitSubunitsRelationWorksheetsRelationSubunitRelation = {
  __typename?: 'UnitSubunitsRelationWorksheetsRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type UnitUpdateInput = {
  bookId?: InputMaybe<Scalars['Int']['input']>;
  edukitaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMarkingSessionOverride = {
  __typename?: 'UpsertMarkingSessionOverride';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markingSessionId: Scalars['Int']['output'];
  overrideStatus: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  worksheetSetVersionId: Scalars['Int']['output'];
  worksheetVersionId: Scalars['Int']['output'];
};

export type User = Student | Teacher;

export type VersionWorksheetDetail = {
  __typename?: 'VersionWorksheetDetail';
  book?: Maybe<SetVersionBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<VersionWorksheetPageDetail>>>;
  subunit?: Maybe<SetVersionSubunit>;
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type VersionWorksheetPageDetail = {
  __typename?: 'VersionWorksheetPageDetail';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  questions?: Maybe<Array<Maybe<VersionWorksheetPageQuestion>>>;
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type VersionWorksheetPageQuestion = {
  __typename?: 'VersionWorksheetPageQuestion';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Float']['output'];
};

export type WorkedWorksheetPage = {
  __typename?: 'WorkedWorksheetPage';
  annotationId: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  pageName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  pageVersionId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Worksheet = {
  __typename?: 'Worksheet';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<Page>>>;
};

export type WorksheetAgeRangeEndFilters = {
  OR?: InputMaybe<Array<WorksheetAgeRangeEndfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeEndfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeStartFilters = {
  OR?: InputMaybe<Array<WorksheetAgeRangeStartfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAgeRangeStartfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyFiltersOr>>;
  id?: InputMaybe<WorksheetAnswerKeyIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetAnswerKeyWorksheetPageVersionIdFilters>;
};

export type WorksheetAnswerKeyFiltersOr = {
  id?: InputMaybe<WorksheetAnswerKeyIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetAnswerKeyWorksheetPageVersionIdFilters>;
};

export type WorksheetAnswerKeyIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyItem = {
  __typename?: 'WorksheetAnswerKeyItem';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetAnswerKeySelectItem = {
  __typename?: 'WorksheetAnswerKeySelectItem';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeySelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetAnswerKeySelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionFilenameFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionFilenamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionFilenamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionFiltersOr>>;
  filename?: InputMaybe<WorksheetAnswerKeyVersionFilenameFilters>;
  id?: InputMaybe<WorksheetAnswerKeyVersionIdFilters>;
  version?: InputMaybe<WorksheetAnswerKeyVersionVersionFilters>;
  worksheetAnswerKeyId?: InputMaybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters>;
};

export type WorksheetAnswerKeyVersionFiltersOr = {
  filename?: InputMaybe<WorksheetAnswerKeyVersionFilenameFilters>;
  id?: InputMaybe<WorksheetAnswerKeyVersionIdFilters>;
  version?: InputMaybe<WorksheetAnswerKeyVersionVersionFilters>;
  worksheetAnswerKeyId?: InputMaybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters>;
};

export type WorksheetAnswerKeyVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionInsertInput = {
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetAnswerKeyId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionItem = {
  __typename?: 'WorksheetAnswerKeyVersionItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionOrderBy = {
  filename?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetAnswerKeyId?: InputMaybe<InnerOrder>;
};

export type WorksheetAnswerKeyVersionSelectItem = {
  __typename?: 'WorksheetAnswerKeyVersionSelectItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionSelectItemWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetAnswerKeyVersionUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetAnswerKeyId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAnswerKeyVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetAnswerKeyWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetAnswerKeyWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetBookOrderFilters = {
  OR?: InputMaybe<Array<WorksheetBookOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetBookOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDescriptionFilters = {
  OR?: InputMaybe<Array<WorksheetDescriptionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDescriptionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetDetail = {
  __typename?: 'WorksheetDetail';
  book?: Maybe<WorksheetDetailBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunit?: Maybe<WorksheetDetailSubunit>;
  versions?: Maybe<Array<Maybe<WorksheetVersion>>>;
};

export type WorksheetDetailBook = {
  __typename?: 'WorksheetDetailBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetDetailSubunit = {
  __typename?: 'WorksheetDetailSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetFilters = {
  OR?: InputMaybe<Array<WorksheetFiltersOr>>;
  ageRangeEnd?: InputMaybe<WorksheetAgeRangeEndFilters>;
  ageRangeStart?: InputMaybe<WorksheetAgeRangeStartFilters>;
  bookOrder?: InputMaybe<WorksheetBookOrderFilters>;
  description?: InputMaybe<WorksheetDescriptionFilters>;
  id?: InputMaybe<WorksheetIdFilters>;
  name?: InputMaybe<WorksheetNameFilters>;
  schoolGradeEnd?: InputMaybe<WorksheetSchoolGradeEndFilters>;
  schoolGradeStart?: InputMaybe<WorksheetSchoolGradeStartFilters>;
  subunitId?: InputMaybe<WorksheetSubunitIdFilters>;
  textIdentifier?: InputMaybe<WorksheetTextIdentifierFilters>;
};

export type WorksheetFiltersOr = {
  ageRangeEnd?: InputMaybe<WorksheetAgeRangeEndFilters>;
  ageRangeStart?: InputMaybe<WorksheetAgeRangeStartFilters>;
  bookOrder?: InputMaybe<WorksheetBookOrderFilters>;
  description?: InputMaybe<WorksheetDescriptionFilters>;
  id?: InputMaybe<WorksheetIdFilters>;
  name?: InputMaybe<WorksheetNameFilters>;
  schoolGradeEnd?: InputMaybe<WorksheetSchoolGradeEndFilters>;
  schoolGradeStart?: InputMaybe<WorksheetSchoolGradeStartFilters>;
  subunitId?: InputMaybe<WorksheetSubunitIdFilters>;
  textIdentifier?: InputMaybe<WorksheetTextIdentifierFilters>;
};

export type WorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetInsertInput = {
  ageRangeEnd: Scalars['Int']['input'];
  ageRangeStart: Scalars['Int']['input'];
  bookOrder: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  schoolGradeEnd: Scalars['String']['input'];
  schoolGradeStart: Scalars['String']['input'];
  subunitId?: InputMaybe<Scalars['Int']['input']>;
  textIdentifier: Scalars['String']['input'];
};

export type WorksheetItem = {
  __typename?: 'WorksheetItem';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetNameFilters = {
  OR?: InputMaybe<Array<WorksheetNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetOrderBy = {
  ageRangeEnd?: InputMaybe<InnerOrder>;
  ageRangeStart?: InputMaybe<InnerOrder>;
  bookOrder?: InputMaybe<InnerOrder>;
  description?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  schoolGradeEnd?: InputMaybe<InnerOrder>;
  schoolGradeStart?: InputMaybe<InnerOrder>;
  subunitId?: InputMaybe<InnerOrder>;
  textIdentifier?: InputMaybe<InnerOrder>;
};

export type WorksheetPage = {
  __typename?: 'WorksheetPage';
  filename?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['Int']['output'];
  pageName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  pageVersionId: Scalars['Int']['output'];
};

export type WorksheetPageAnnotation = {
  __typename?: 'WorksheetPageAnnotation';
  drawing?: Maybe<Scalars['JSON']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  textboxes?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  worksheetPageVersionId: Scalars['Int']['output'];
};

export type WorksheetPageAnnotationCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationDrawingFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationDrawingfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationDrawingfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationFiltersOr>>;
  createdAt?: InputMaybe<WorksheetPageAnnotationCreatedAtFilters>;
  drawing?: InputMaybe<WorksheetPageAnnotationDrawingFilters>;
  garageUserId?: InputMaybe<WorksheetPageAnnotationGarageUserIdFilters>;
  id?: InputMaybe<WorksheetPageAnnotationIdFilters>;
  role?: InputMaybe<WorksheetPageAnnotationRoleFilters>;
  textboxes?: InputMaybe<WorksheetPageAnnotationTextboxesFilters>;
  updatedAt?: InputMaybe<WorksheetPageAnnotationUpdatedAtFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageAnnotationWorksheetPageVersionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<WorksheetPageAnnotationWorksheetSetAssignmentIdFilters>;
};

export type WorksheetPageAnnotationFiltersOr = {
  createdAt?: InputMaybe<WorksheetPageAnnotationCreatedAtFilters>;
  drawing?: InputMaybe<WorksheetPageAnnotationDrawingFilters>;
  garageUserId?: InputMaybe<WorksheetPageAnnotationGarageUserIdFilters>;
  id?: InputMaybe<WorksheetPageAnnotationIdFilters>;
  role?: InputMaybe<WorksheetPageAnnotationRoleFilters>;
  textboxes?: InputMaybe<WorksheetPageAnnotationTextboxesFilters>;
  updatedAt?: InputMaybe<WorksheetPageAnnotationUpdatedAtFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageAnnotationWorksheetPageVersionIdFilters>;
  worksheetSetAssignmentId?: InputMaybe<WorksheetPageAnnotationWorksheetSetAssignmentIdFilters>;
};

export type WorksheetPageAnnotationGarageUserIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationGarageUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationGarageUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  drawing?: InputMaybe<Scalars['String']['input']>;
  garageUserId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageAnnotationItem = {
  __typename?: 'WorksheetPageAnnotationItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  /** JSON */
  drawing?: Maybe<Scalars['String']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  drawing?: InputMaybe<InnerOrder>;
  garageUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  role?: InputMaybe<InnerOrder>;
  textboxes?: InputMaybe<InnerOrder>;
  updatedAt?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
  worksheetSetAssignmentId?: InputMaybe<InnerOrder>;
};

export enum WorksheetPageAnnotationRoleEnum {
  /** Value: ops */
  Ops = 'ops',
  /** Value: parent */
  Parent = 'parent',
  /** Value: student */
  Student = 'student',
  /** Value: teacher */
  Teacher = 'teacher'
}

export type WorksheetPageAnnotationRoleFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationRolefiltersOr>>;
  eq?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  lte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ne?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationRolefiltersOr = {
  eq?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  gte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  lte?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  ne?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<WorksheetPageAnnotationRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationSelectItem = {
  __typename?: 'WorksheetPageAnnotationSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  /** JSON */
  drawing?: Maybe<Scalars['String']['output']>;
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: WorksheetPageAnnotationRoleEnum;
  /** JSON */
  textboxes?: Maybe<Scalars['String']['output']>;
  /** Date */
  updatedAt: Scalars['String']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationSelectItemWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationTextboxesFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationTextboxesfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationTextboxesfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  drawing?: InputMaybe<Scalars['String']['input']>;
  garageUserId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<WorksheetPageAnnotationRoleEnum>;
  /** JSON */
  textboxes?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageAnnotationUpdatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationUpdatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationUpdatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageAnnotationWorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageAnnotationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageDetail = {
  __typename?: 'WorksheetPageDetail';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions?: Maybe<Array<Maybe<WorksheetPageVersion>>>;
};

export type WorksheetPageFilters = {
  OR?: InputMaybe<Array<WorksheetPageFiltersOr>>;
  id?: InputMaybe<WorksheetPageIdFilters>;
  name?: InputMaybe<WorksheetPageNameFilters>;
  pageNumber?: InputMaybe<WorksheetPagePageNumberFilters>;
  worksheetId?: InputMaybe<WorksheetPageWorksheetIdFilters>;
};

export type WorksheetPageFiltersOr = {
  id?: InputMaybe<WorksheetPageIdFilters>;
  name?: InputMaybe<WorksheetPageNameFilters>;
  pageNumber?: InputMaybe<WorksheetPagePageNumberFilters>;
  worksheetId?: InputMaybe<WorksheetPageWorksheetIdFilters>;
};

export type WorksheetPageIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageItem = {
  __typename?: 'WorksheetPageItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageNameFilters = {
  OR?: InputMaybe<Array<WorksheetPageNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageOrderBy = {
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  pageNumber?: InputMaybe<InnerOrder>;
  worksheetId?: InputMaybe<InnerOrder>;
};

export type WorksheetPagePageNumberFilters = {
  OR?: InputMaybe<Array<WorksheetPagePageNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPagePageNumberfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionContentFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionContentfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionContentfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionFiltersOr>>;
  content?: InputMaybe<WorksheetPageQuestionContentFilters>;
  id?: InputMaybe<WorksheetPageQuestionIdFilters>;
  totalPoints?: InputMaybe<WorksheetPageQuestionTotalPointsFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageQuestionWorksheetPageVersionIdFilters>;
};

export type WorksheetPageQuestionFiltersOr = {
  content?: InputMaybe<WorksheetPageQuestionContentFilters>;
  id?: InputMaybe<WorksheetPageQuestionIdFilters>;
  totalPoints?: InputMaybe<WorksheetPageQuestionTotalPointsFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetPageQuestionWorksheetPageVersionIdFilters>;
};

export type WorksheetPageQuestionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionInsertInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  totalPoints: Scalars['Int']['input'];
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageQuestionItem = {
  __typename?: 'WorksheetPageQuestionItem';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageQuestionMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionOrderBy = {
  content?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  totalPoints?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetPageQuestionSelectItem = {
  __typename?: 'WorksheetPageQuestionSelectItem';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageQuestionMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionSelectItemMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageQuestionSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionTotalPointsFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionTotalPointsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionTotalPointsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageQuestionWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageQuestionWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageSelectItem = {
  __typename?: 'WorksheetPageSelectItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelation>;
  worksheet?: Maybe<WorksheetPageWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageSelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageSelectItemWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersion = {
  __typename?: 'WorksheetPageVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetPageVersionFilenameFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionFilenamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionFilenamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionFiltersOr>>;
  filename?: InputMaybe<WorksheetPageVersionFilenameFilters>;
  id?: InputMaybe<WorksheetPageVersionIdFilters>;
  version?: InputMaybe<WorksheetPageVersionVersionFilters>;
  worksheetPageId?: InputMaybe<WorksheetPageVersionWorksheetPageIdFilters>;
};

export type WorksheetPageVersionFiltersOr = {
  filename?: InputMaybe<WorksheetPageVersionFilenameFilters>;
  id?: InputMaybe<WorksheetPageVersionIdFilters>;
  version?: InputMaybe<WorksheetPageVersionVersionFilters>;
  worksheetPageId?: InputMaybe<WorksheetPageVersionWorksheetPageIdFilters>;
};

export type WorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionInsertInput = {
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetPageId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersionItem = {
  __typename?: 'WorksheetPageVersionItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionOrderBy = {
  filename?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetPageId?: InputMaybe<InnerOrder>;
};

export type WorksheetPageVersionSelectItem = {
  __typename?: 'WorksheetPageVersionSelectItem';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageVersionWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelation>;
};


export type WorksheetPageVersionSelectItemWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageVersionSelectItemWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageVersionSelectItemWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetPageVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageVersionWorksheetPageIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetPageIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageVersionWorksheetPageRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetPageVersionsRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetPageVersionsRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetPageRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetPageVersionsRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageWorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetPageWorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageWorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetPageWorksheetRelation = {
  __typename?: 'WorksheetPageWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetPageWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetPageWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSchoolGradeEndFilters = {
  OR?: InputMaybe<Array<WorksheetSchoolGradeEndfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeEndfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeStartFilters = {
  OR?: InputMaybe<Array<WorksheetSchoolGradeStartfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSchoolGradeStartfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSelectItem = {
  __typename?: 'WorksheetSelectItem';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSelectItemSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentFiltersOr>>;
  createdAt?: InputMaybe<WorksheetSetAssignmentCreatedAtFilters>;
  garageClassroomSessionId?: InputMaybe<WorksheetSetAssignmentGarageClassroomSessionIdFilters>;
  garageUserId?: InputMaybe<WorksheetSetAssignmentGarageUserIdFilters>;
  id?: InputMaybe<WorksheetSetAssignmentIdFilters>;
  isMarkingComplete?: InputMaybe<WorksheetSetAssignmentIsMarkingCompleteFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetAssignmentWorksheetSetVersionIdFilters>;
};

export type WorksheetSetAssignmentFiltersOr = {
  createdAt?: InputMaybe<WorksheetSetAssignmentCreatedAtFilters>;
  garageClassroomSessionId?: InputMaybe<WorksheetSetAssignmentGarageClassroomSessionIdFilters>;
  garageUserId?: InputMaybe<WorksheetSetAssignmentGarageUserIdFilters>;
  id?: InputMaybe<WorksheetSetAssignmentIdFilters>;
  isMarkingComplete?: InputMaybe<WorksheetSetAssignmentIsMarkingCompleteFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetAssignmentWorksheetSetVersionIdFilters>;
};

export type WorksheetSetAssignmentGarageClassroomSessionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentGarageClassroomSessionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageClassroomSessionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageUserIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentGarageUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentGarageUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isMarkingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetAssignmentIsMarkingCompleteFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentIsMarkingCompletefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentIsMarkingCompletefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentItem = {
  __typename?: 'WorksheetSetAssignmentItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  garageClassroomSessionId?: InputMaybe<InnerOrder>;
  garageUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isMarkingComplete?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetAssignmentSelectItem = {
  __typename?: 'WorksheetSetAssignmentSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetAssignmentUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  garageClassroomSessionId?: InputMaybe<Scalars['Int']['input']>;
  garageUserId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMarkingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetAssignmentWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetDescriptionFilters = {
  OR?: InputMaybe<Array<WorksheetSetDescriptionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetDescriptionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetDetail = {
  __typename?: 'WorksheetSetDetail';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  versions?: Maybe<Array<Maybe<WorksheetSetVersion>>>;
};

export type WorksheetSetFilters = {
  OR?: InputMaybe<Array<WorksheetSetFiltersOr>>;
  description?: InputMaybe<WorksheetSetDescriptionFilters>;
  gaudiaLevelId?: InputMaybe<WorksheetSetGaudiaLevelIdFilters>;
  id?: InputMaybe<WorksheetSetIdFilters>;
  name?: InputMaybe<WorksheetSetNameFilters>;
  order?: InputMaybe<WorksheetSetOrderFilters>;
};

export type WorksheetSetFiltersOr = {
  description?: InputMaybe<WorksheetSetDescriptionFilters>;
  gaudiaLevelId?: InputMaybe<WorksheetSetGaudiaLevelIdFilters>;
  id?: InputMaybe<WorksheetSetIdFilters>;
  name?: InputMaybe<WorksheetSetNameFilters>;
  order?: InputMaybe<WorksheetSetOrderFilters>;
};

export type WorksheetSetGaudiaLevelIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetGaudiaLevelIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetGaudiaLevelIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetInsertInput = {
  description: Scalars['String']['input'];
  gaudiaLevelId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type WorksheetSetItem = {
  __typename?: 'WorksheetSetItem';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorksheetSetNameFilters = {
  OR?: InputMaybe<Array<WorksheetSetNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetOrderBy = {
  description?: InputMaybe<InnerOrder>;
  gaudiaLevelId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  order?: InputMaybe<InnerOrder>;
};

export type WorksheetSetOrderFilters = {
  OR?: InputMaybe<Array<WorksheetSetOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetSelectItem = {
  __typename?: 'WorksheetSetSelectItem';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelation>;
};


export type WorksheetSetSelectItemVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gaudiaLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersion = {
  __typename?: 'WorksheetSetVersion';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetSetVersionAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionDetail = {
  __typename?: 'WorksheetSetVersionDetail';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheets?: Maybe<Array<Maybe<VersionWorksheetDetail>>>;
};

export type WorksheetSetVersionFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionFiltersOr>>;
  createdAt?: InputMaybe<WorksheetSetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetSetVersionIdFilters>;
  version?: InputMaybe<WorksheetSetVersionVersionFilters>;
  worksheetSetId?: InputMaybe<WorksheetSetVersionWorksheetSetIdFilters>;
};

export type WorksheetSetVersionFiltersOr = {
  createdAt?: InputMaybe<WorksheetSetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetSetVersionIdFilters>;
  version?: InputMaybe<WorksheetSetVersionVersionFilters>;
  worksheetSetId?: InputMaybe<WorksheetSetVersionWorksheetSetIdFilters>;
};

export type WorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItem = {
  __typename?: 'WorksheetSetVersionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemFiltersOr>>;
  id?: InputMaybe<WorksheetSetVersionItemIdFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetSetVersionItemFiltersOr = {
  id?: InputMaybe<WorksheetSetVersionItemIdFilters>;
  worksheetSetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetSetVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetSetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetSetVersionItemIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItemItem = {
  __typename?: 'WorksheetSetVersionItemItem';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetSetVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetVersionItemSelectItem = {
  __typename?: 'WorksheetSetVersionItemSelectItem';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemSelectItemWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionItemSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionItemUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemWorksheetSetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionItemWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetSetId?: InputMaybe<InnerOrder>;
};

export type WorksheetSetVersionSelectItem = {
  __typename?: 'WorksheetSetVersionSelectItem';
  assignments: Array<WorksheetSetVersionAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionSelectItemAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionSelectItemWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionSelectItemWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetSetVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetIdFilters = {
  OR?: InputMaybe<Array<WorksheetSetVersionWorksheetSetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSetVersionWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetRelationVersionsRelation>;
};


export type WorksheetSetVersionWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelation';
  assignments: Array<WorksheetSetVersionsRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetSetVersionsRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetSetVersionsRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetSetVersionsRelationAssignmentsRelation = {
  __typename?: 'WorksheetSetVersionsRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSubunitIdFilters = {
  OR?: InputMaybe<Array<WorksheetSubunitIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSubunitIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetSubunitRelation = {
  __typename?: 'WorksheetSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetSubunitRelationWorksheetsRelation>;
};


export type WorksheetSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetSubunitRelationUnitRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelation';
  book?: Maybe<WorksheetSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetTextIdentifierFilters = {
  OR?: InputMaybe<Array<WorksheetTextIdentifierfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetTextIdentifierfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetUpdateInput = {
  ageRangeEnd?: InputMaybe<Scalars['Int']['input']>;
  ageRangeStart?: InputMaybe<Scalars['Int']['input']>;
  bookOrder?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolGradeEnd?: InputMaybe<Scalars['String']['input']>;
  schoolGradeStart?: InputMaybe<Scalars['String']['input']>;
  subunitId?: InputMaybe<Scalars['Int']['input']>;
  textIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersion = {
  __typename?: 'WorksheetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type WorksheetVersionCreatedAtFilters = {
  OR?: InputMaybe<Array<WorksheetVersionCreatedAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionCreatedAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionDetail = {
  __typename?: 'WorksheetVersionDetail';
  id: Scalars['Int']['output'];
  pages?: Maybe<Array<Maybe<WorksheetVersionDetailWorksheetPageDetail>>>;
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionDetailWorksheetDetail>;
};

export type WorksheetVersionDetailBook = {
  __typename?: 'WorksheetVersionDetailBook';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionDetailSubunit = {
  __typename?: 'WorksheetVersionDetailSubunit';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionDetailWorksheetDetail = {
  __typename?: 'WorksheetVersionDetailWorksheetDetail';
  book?: Maybe<WorksheetVersionDetailBook>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<WorksheetVersionDetailWorksheetPageDetail>>>;
  subunit?: Maybe<WorksheetVersionDetailSubunit>;
};

export type WorksheetVersionDetailWorksheetPageDetail = {
  __typename?: 'WorksheetVersionDetailWorksheetPageDetail';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type WorksheetVersionFilters = {
  OR?: InputMaybe<Array<WorksheetVersionFiltersOr>>;
  createdAt?: InputMaybe<WorksheetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetVersionIdFilters>;
  version?: InputMaybe<WorksheetVersionVersionFilters>;
  worksheetId?: InputMaybe<WorksheetVersionWorksheetIdFilters>;
};

export type WorksheetVersionFiltersOr = {
  createdAt?: InputMaybe<WorksheetVersionCreatedAtFilters>;
  id?: InputMaybe<WorksheetVersionIdFilters>;
  version?: InputMaybe<WorksheetVersionVersionFilters>;
  worksheetId?: InputMaybe<WorksheetVersionWorksheetIdFilters>;
};

export type WorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionInsertInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItem = {
  __typename?: 'WorksheetVersionItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemFiltersOr>>;
  id?: InputMaybe<WorksheetVersionItemIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetVersionItemWorksheetPageVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetVersionItemFiltersOr = {
  id?: InputMaybe<WorksheetVersionItemIdFilters>;
  worksheetPageVersionId?: InputMaybe<WorksheetVersionItemWorksheetPageVersionIdFilters>;
  worksheetVersionId?: InputMaybe<WorksheetVersionItemWorksheetVersionIdFilters>;
};

export type WorksheetVersionItemIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItemItem = {
  __typename?: 'WorksheetVersionItemItem';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemOrderBy = {
  id?: InputMaybe<InnerOrder>;
  worksheetPageVersionId?: InputMaybe<InnerOrder>;
  worksheetVersionId?: InputMaybe<InnerOrder>;
};

export type WorksheetVersionItemSelectItem = {
  __typename?: 'WorksheetVersionItemSelectItem';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemSelectItemWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionItemSelectItemWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemUpdateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  worksheetPageVersionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemWorksheetPageVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionItemWorksheetVersionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetVersionIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionItemWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionItemWorksheetVersionRelationWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionOrderBy = {
  createdAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  version?: InputMaybe<InnerOrder>;
  worksheetId?: InputMaybe<InnerOrder>;
};

export type WorksheetVersionSelectItem = {
  __typename?: 'WorksheetVersionSelectItem';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheet?: Maybe<WorksheetVersionWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetSetVersionItemsRelation>;
  worksheetVersionItems: Array<WorksheetVersionWorksheetVersionItemsRelation>;
};


export type WorksheetVersionSelectItemWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};


export type WorksheetVersionSelectItemWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};


export type WorksheetVersionSelectItemWorksheetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetVersionItemFilters>;
};

export type WorksheetVersionUpdateInput = {
  /** Date */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  worksheetId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetVersionVersionFilters = {
  OR?: InputMaybe<Array<WorksheetVersionVersionfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionVersionfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetIdFilters = {
  OR?: InputMaybe<Array<WorksheetVersionWorksheetIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetVersionWorksheetRelation = {
  __typename?: 'WorksheetVersionWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationAssignmentsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation>;
  worksheetPage?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation>;
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
  worksheetQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageArgs = {
  where?: InputMaybe<WorksheetPageFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageQuestionOrderBy>;
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation>;
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetAnswerKeyVersionOrderBy>;
  where?: InputMaybe<WorksheetAnswerKeyVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetAnswerKey?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation>;
  worksheetAnswerKeyId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyArgs = {
  where?: InputMaybe<WorksheetAnswerKeyFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationVersionsRelationWorksheetAnswerKeyRelation';
  id: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetAnswerKeyRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation>;
  worksheet?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation>;
  worksheetId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetPageVersionOrderBy>;
  where?: InputMaybe<WorksheetPageVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetArgs = {
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationVersionsRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunit?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation>;
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitArgs = {
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation>;
  unitId?: Maybe<Scalars['Int']['output']>;
  worksheets: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetOrderBy>;
  where?: InputMaybe<WorksheetFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelation';
  book?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation>;
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subunits: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookArgs = {
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelArgs = {
  where?: InputMaybe<EdukitaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubunitOrderBy>;
  where?: InputMaybe<SubunitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationGaudiaLevelRelationEdukitaLevelsRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationBookRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelation';
  books: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation>;
  edukitaLevels: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BookOrderBy>;
  where?: InputMaybe<BookFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EdukitaLevelOrderBy>;
  where?: InputMaybe<EdukitaLevelFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelation';
  gaudiaLevel?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation>;
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  units: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelArgs = {
  where?: InputMaybe<GaudiaLevelFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UnitOrderBy>;
  where?: InputMaybe<UnitFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationGaudiaLevelRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationBooksRelationUnitsRelation';
  bookId?: Maybe<Scalars['Int']['output']>;
  edukitaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationEdukitaLevelRelationGaudiaLevelRelationEdukitaLevelsRelation';
  gaudiaLevelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationUnitRelationSubunitsRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelationWorksheetRelationSubunitRelationWorksheetsRelation';
  ageRangeEnd: Scalars['Int']['output'];
  ageRangeStart: Scalars['Int']['output'];
  bookOrder: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  schoolGradeEnd: Scalars['String']['output'];
  schoolGradeStart: Scalars['String']['output'];
  subunitId?: Maybe<Scalars['Int']['output']>;
  textIdentifier: Scalars['String']['output'];
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation>;
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation>;
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionArgs = {
  where?: InputMaybe<WorksheetPageVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSession?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation>;
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation>;
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionArgs = {
  where?: InputMaybe<MarkingSessionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionArgs = {
  where?: InputMaybe<WorksheetPageQuestionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  markedQuestions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation>;
  worksheetSetAssignment?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation>;
  worksheetSetAssignmentId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MarkedQuestionOrderBy>;
  where?: InputMaybe<MarkedQuestionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentArgs = {
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationMarkedQuestionsRelation';
  id: Scalars['Int']['output'];
  markingSessionId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  worksheetPageQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelation';
  assignments: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation>;
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSet?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation>;
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
  worksheetSetVersionItems: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetAssignmentOrderBy>;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetArgs = {
  where?: InputMaybe<WorksheetSetFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionItemOrderBy>;
  where?: InputMaybe<WorksheetSetVersionItemFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationAssignmentsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  garageClassroomSessionId: Scalars['Int']['output'];
  garageUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMarkingComplete: Scalars['Boolean']['output'];
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelation';
  description: Scalars['String']['output'];
  gaudiaLevelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  versions: Array<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorksheetSetVersionOrderBy>;
  where?: InputMaybe<WorksheetSetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetRelationVersionsRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelation';
  id: Scalars['Int']['output'];
  worksheetSetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation>;
  worksheetSetVersionId?: Maybe<Scalars['Int']['output']>;
  worksheetVersion?: Maybe<WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation>;
  worksheetVersionId?: Maybe<Scalars['Int']['output']>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionArgs = {
  where?: InputMaybe<WorksheetSetVersionFilters>;
};


export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionArgs = {
  where?: InputMaybe<WorksheetVersionFilters>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetSetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetSetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelationWorksheetSetAssignmentRelationWorksheetSetVersionRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationMarkedQuestionsRelationWorksheetPageQuestionRelation';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  worksheetPageVersionId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetQuestionsRelationWorksheetPageVersionRelation';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetPageId?: Maybe<Scalars['Int']['output']>;
};

export type WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation = {
  __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetVersionRelation';
  /** Date */
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  worksheetId?: Maybe<Scalars['Int']['output']>;
};

export type InsertWorksheetSetAssignmentMutationVariables = Exact<{
  values: WorksheetSetAssignmentInsertInput;
}>;


export type InsertWorksheetSetAssignmentMutation = { __typename?: 'Mutation', insertIntoWorksheetSetAssignmentSingle?: { __typename: 'WorksheetSetAssignmentItem', id: number, garageUserId: number, worksheetSetVersionId?: number | null, garageClassroomSessionId: number, isMarkingComplete: boolean } | null };

export type UpdateWorksheetSetAssignmentMutationVariables = Exact<{
  set: WorksheetSetAssignmentUpdateInput;
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
}>;


export type UpdateWorksheetSetAssignmentMutation = { __typename?: 'Mutation', updateWorksheetSetAssignment: Array<{ __typename: 'WorksheetSetAssignmentItem', id: number, garageUserId: number, worksheetSetVersionId?: number | null, garageClassroomSessionId: number, isMarkingComplete: boolean }> };

export type UpsertMarkingSessionMutationVariables = Exact<{
  worksheetSetAssignmentId: Scalars['Int']['input'];
  markedQuestions: Array<MarkedQuestionInput> | MarkedQuestionInput;
}>;


export type UpsertMarkingSessionMutation = { __typename?: 'Mutation', upsertMarkingSession?: { __typename?: 'MarkingSessionResponse', sessionId: number } | null };

export type UpsertMarkingSessionOverrideMutationVariables = Exact<{
  markingSessionId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
  overrideStatus: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertMarkingSessionOverrideMutation = { __typename?: 'Mutation', upsertMarkingSessionOverride?: { __typename?: 'UpsertMarkingSessionOverride', id: number, markingSessionId: number, worksheetSetVersionId: number, worksheetVersionId: number, overrideStatus: string, remarks?: string | null, createdAt: string, updatedAt: string } | null };

export type UpsertWorksheetPageAnnotationMutationVariables = Exact<{
  worksheetPageVersionId: Scalars['Int']['input'];
  worksheetSetAssignmentId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  role: Scalars['String']['input'];
  drawing?: InputMaybe<Scalars['JSON']['input']>;
  textboxes?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpsertWorksheetPageAnnotationMutation = { __typename?: 'Mutation', upsertWorksheetPageAnnotation?: { __typename?: 'WorksheetPageAnnotation', id: number, worksheetPageVersionId: number, garageUserId: number, role: string, drawing?: any | null, textboxes?: any | null, updatedAt: string } | null };

export type GetAssignmentsQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
}>;


export type GetAssignmentsQuery = { __typename?: 'Query', getAssignments?: Array<{ __typename: 'Assignment', id: number, isMarkingComplete: boolean, worksheetSetVersion?: { __typename: 'AssigmentWorksheetSetVersion', id: number, version: number, worksheetSet?: { __typename: 'AssigmentWorksheetSet', id: number, name: string, description?: string | null } | null } | null } | null> | null };

export type GetAssignmentDetailQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetAssignmentDetailQuery = { __typename?: 'Query', getAssignmentDetail?: { __typename: 'AssignmentDetail', id: number, isMarkingComplete: boolean, worksheetSetVersion: { __typename: 'AssigmentDetailWorksheetSetVersion', id: number, version: number, worksheetSet: { __typename: 'AssigmenDetailtWorksheetSet', id: number, name: string } } } | null };

export type GetLastWorkedWorksheetPageQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetLastWorkedWorksheetPageQuery = { __typename?: 'Query', getLastWorkedWorksheetPage?: { __typename: 'WorkedWorksheetPage', annotationId: number, updatedAt: string, pageVersionId: number, pageId: number, pageName: string, pageNumber: number } | null };

export type GetLastWorkedWorksheetsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  dayStart: Scalars['String']['input'];
  dayEnd: Scalars['String']['input'];
}>;


export type GetLastWorkedWorksheetsQuery = { __typename?: 'Query', getLastWorkedWorksheets?: Array<{ __typename?: 'LastWorkedWorksheet', worksheetId: number, worksheetName: string, updatedAt: string, subunit?: { __typename?: 'LastWorkedWorksheetSubunit', subunitId: number, subunitName: string } | null, book?: { __typename?: 'LastWorkedWorksheetBook', bookId: number, bookName: string } | null, pages?: Array<{ __typename?: 'WorksheetPage', pageId: number, pageVersionId: number, pageName: string, pageNumber: number, filename?: string | null } | null> | null } | null> | null };

export type GetMarkingSessionOverrideQueryVariables = Exact<{
  where?: InputMaybe<MarkingSessionOverrideFilters>;
}>;


export type GetMarkingSessionOverrideQuery = { __typename?: 'Query', markingSessionOverride: Array<{ __typename?: 'MarkingSessionOverrideSelectItem', id: number, markingSessionId: number, worksheetSetVersionId?: number | null, worksheetVersionId?: number | null, overrideStatus: string, remarks?: string | null, createdAt: string, updatedAt: string }> };

export type GetMarkingSessionSummaryQueryVariables = Exact<{
  garageClassroomSessionId: Scalars['Int']['input'];
  garageUserId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetMarkingSessionSummaryQuery = { __typename?: 'Query', getMarkingSessionSummary?: { __typename?: 'MarkingSessionSummary', id: number, createdAt: string, worksheets?: Array<{ __typename?: 'Worksheet', id: number, name: string, pages?: Array<{ __typename?: 'Page', id: number, name: string, pageNumber: number, questions?: Array<{ __typename?: 'Question', id: number, content: string, totalPoints: number, markedQuestions?: Array<{ __typename?: 'MarkedQuestion', id: number, points: number } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetMarkingSessionsQueryVariables = Exact<{
  where?: InputMaybe<MarkingSessionFilters>;
}>;


export type GetMarkingSessionsQuery = { __typename?: 'Query', markingSession: Array<{ __typename?: 'MarkingSessionSelectItem', id: number, worksheetSetAssignmentId?: number | null, createdAt: string, markedQuestions: Array<{ __typename?: 'MarkingSessionMarkedQuestionsRelation', id: number, points: number, worksheetPageQuestion?: { __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelation', id: number, content: string, totalPoints: number, worksheetPageVersion?: { __typename?: 'MarkingSessionMarkedQuestionsRelationWorksheetPageQuestionRelationWorksheetPageVersionRelation', id: number } | null } | null }> }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'Student', id: number, name?: string | null, gender?: string | null } | { __typename?: 'Teacher', id: number, name?: string | null, email?: string | null } | null };

export type GetStaffScheduleQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStaffScheduleQuery = { __typename?: 'Query', getStaffSchedule?: Array<{ __typename: 'StaffSchedule', id: number, title: string, is_offline: boolean, day: string, start_time: string, end_time: string, teacher?: { __typename: 'Teacher', id: number, name?: string | null, email?: string | null, from?: string | null, image?: string | null } | null } | null> | null };

export type GetStudentPaginatedQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStudentPaginatedQuery = { __typename?: 'Query', getStudentPaginated?: { __typename?: 'GetStudentPaginated', result?: Array<{ __typename?: 'GetStudentPaginatedItem', parent?: { __typename?: 'Parent', id: number, name?: string | null } | null, student?: { __typename?: 'Student', id: number, name?: string | null } | null } | null> | null, pagination?: { __typename?: 'Pagination', page?: number | null, per_page?: number | null } | null } | null };

export type GetStudentsByClassroomSessionQueryVariables = Exact<{
  sessionId: Scalars['Int']['input'];
}>;


export type GetStudentsByClassroomSessionQuery = { __typename?: 'Query', getStudentsByClassroomSession?: { __typename: 'ClassroomSessionWithStudents', session?: { __typename: 'Session', id?: number | null, title?: string | null, is_offline?: boolean | null, link?: string | null, bts_id?: string | null, use_bts?: boolean | null, day?: string | null, start_timestamp?: string | null, end_timestamp?: string | null, course_id?: number | null, topic?: string | null, grade?: string | null, teacher?: { __typename: 'Teacher', id: number, name?: string | null, from?: string | null, image?: string | null } | null } | null, students?: Array<{ __typename: 'Student', id: number, name?: string | null, nickname?: string | null, is_trial?: boolean | null, active_subscription?: boolean | null } | null> | null } | null };

export type GetWorksheetDetailQueryVariables = Exact<{
  worksheetId: Scalars['Int']['input'];
}>;


export type GetWorksheetDetailQuery = { __typename?: 'Query', getWorksheetDetail?: { __typename: 'WorksheetDetail', id: number, name: string, subunit?: { __typename: 'WorksheetDetailSubunit', id: number, name: string } | null, book?: { __typename: 'WorksheetDetailBook', id: number, name: string } | null, versions?: Array<{ __typename: 'WorksheetVersion', id: number, version: number } | null> | null } | null };

export type GetWorksheetPageDetailQueryVariables = Exact<{
  worksheetPageId: Scalars['Int']['input'];
}>;


export type GetWorksheetPageDetailQuery = { __typename?: 'Query', getWorksheetPageDetail?: { __typename: 'WorksheetPageDetail', id: number, name: string, pageNumber: number, versions?: Array<{ __typename: 'WorksheetPageVersion', id: number, version: number } | null> | null } | null };

export type GetWorksheetPageVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetPageVersionFilters>;
}>;


export type GetWorksheetPageVersionQuery = { __typename?: 'Query', worksheetPageVersion: Array<{ __typename?: 'WorksheetPageVersionSelectItem', id: number, filename: string, version: number, worksheetAnswerKey?: { __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelation', id: number, versions: Array<{ __typename?: 'WorksheetPageVersionWorksheetAnswerKeyRelationVersionsRelation', id: number, filename: string, version: number }> } | null, worksheetQuestions: Array<{ __typename?: 'WorksheetPageVersionWorksheetQuestionsRelation', id: number, content: string, totalPoints: number, markedQuestions: Array<{ __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelation', id: number, points: number, markingSession?: { __typename?: 'WorksheetPageVersionWorksheetQuestionsRelationMarkedQuestionsRelationMarkingSessionRelation', id: number } | null }> }> }> };

export type GetWorksheetPageVersionDetailQueryVariables = Exact<{
  worksheetPageVersionId: Scalars['Int']['input'];
  markingSessionId?: InputMaybe<Scalars['Int']['input']>;
  worksheetSetAssignmentId: Scalars['Int']['input'];
}>;


export type GetWorksheetPageVersionDetailQuery = { __typename?: 'Query', getWorksheetPageVersionDetail?: { __typename: 'PageVersionPage', id: number, version?: number | null, page?: { __typename: 'PageVersionPageDetail', name?: string | null, pageNumber?: number | null } | null, questions?: Array<{ __typename: 'PageVersionQuestion', id: number, content?: string | null, totalPoints?: number | null, markedQuestion?: { __typename: 'PageVersionMarkedQuestion', id: number, points?: number | null } | null } | null> | null, annotations?: { __typename: 'PageVersionAnnotations', student?: Array<{ __typename: 'PageVersionAnnotation', id: number, drawing?: Array<{ __typename: 'PageVersionDrawing', stroke?: number | null, color?: string | null, mode?: number | null, path?: Array<Array<number | null> | null> | null } | null> | null, textboxes?: Array<{ __typename: 'PageVersionTextbox', text?: string | null, fontSize?: number | null, position?: { __typename: 'PageVersionTextboxPosition', x?: number | null, y?: number | null } | null } | null> | null } | null> | null, teacher?: Array<{ __typename: 'PageVersionAnnotation', id: number, drawing?: Array<{ __typename: 'PageVersionDrawing', stroke?: number | null, color?: string | null, mode?: number | null, path?: Array<Array<number | null> | null> | null } | null> | null, textboxes?: Array<{ __typename: 'PageVersionTextbox', text?: string | null, fontSize?: number | null, position?: { __typename: 'PageVersionTextboxPosition', x?: number | null, y?: number | null } | null } | null> | null } | null> | null } | null, answerKey?: { __typename: 'PageVersionAnswerKey', id: number, versionId?: number | null, filename?: string | null } | null } | null };

export type GetWorksheetSetAssigmentQueryVariables = Exact<{
  where?: InputMaybe<WorksheetSetAssignmentFilters>;
}>;


export type GetWorksheetSetAssigmentQuery = { __typename?: 'Query', worksheetSetAssignment: Array<{ __typename: 'WorksheetSetAssignmentSelectItem', id: number, garageUserId: number, garageClassroomSessionId: number, isMarkingComplete: boolean, createdAt: string, worksheetSetVersion?: { __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelation', id: number, version: number, worksheetSet?: { __typename: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetRelation', id: number, name: string, order: number, description: string } | null, worksheetSetVersionItems: Array<{ __typename?: 'WorksheetSetAssignmentWorksheetSetVersionRelationWorksheetSetVersionItemsRelation', id: number, worksheetSetVersionId?: number | null, worksheetVersionId?: number | null }> } | null }> };

export type GetWorksheetSetDetailQueryVariables = Exact<{
  worksheetSetId: Scalars['Int']['input'];
}>;


export type GetWorksheetSetDetailQuery = { __typename?: 'Query', getWorksheetSetDetail?: { __typename: 'WorksheetSetDetail', id: number, name: string, versions?: Array<{ __typename: 'WorksheetSetVersion', id: number, version: number, createdAt: string } | null> | null } | null };

export type GetWorksheetSetVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetSetVersionFilters>;
}>;


export type GetWorksheetSetVersionQuery = { __typename?: 'Query', worksheetSetVersion: Array<{ __typename?: 'WorksheetSetVersionSelectItem', id: number, version: number, assignments: Array<{ __typename?: 'WorksheetSetVersionAssignmentsRelation', garageClassroomSessionId: number }>, worksheetSet?: { __typename?: 'WorksheetSetVersionWorksheetSetRelation', id: number, name: string, order: number, versions: Array<{ __typename?: 'WorksheetSetVersionWorksheetSetRelationVersionsRelation', id: number, version: number, worksheetSetId?: number | null }> } | null, worksheetSetVersionItems: Array<{ __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelation', id: number, worksheetVersion?: { __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelation', id: number, version: number, worksheet?: { __typename?: 'WorksheetSetVersionWorksheetSetVersionItemsRelationWorksheetVersionRelationWorksheetRelation', id: number, name: string, bookOrder: number } | null } | null }> }> };

export type GetWorksheetSetVersionDetailQueryVariables = Exact<{
  worksheetSetId: Scalars['Int']['input'];
  worksheetSetVersionId: Scalars['Int']['input'];
}>;


export type GetWorksheetSetVersionDetailQuery = { __typename?: 'Query', getWorksheetSetVersionDetail?: { __typename: 'WorksheetSetVersionDetail', id: number, version: number, createdAt: string, worksheets?: Array<{ __typename: 'VersionWorksheetDetail', id: number, name: string, version: number, versionId: number, subunit?: { __typename: 'SetVersionSubunit', id: number, name: string } | null, book?: { __typename: 'SetVersionBook', id: number, name: string } | null, pages?: Array<{ __typename: 'VersionWorksheetPageDetail', id: number, versionId: number, name: string, pageNumber: number, version: number, filename: string, questions?: Array<{ __typename: 'VersionWorksheetPageQuestion', id: number, content: string, totalPoints: number } | null> | null } | null> | null } | null> | null } | null };

export type GetWorksheetSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorksheetSetsQuery = { __typename?: 'Query', worksheetSet: Array<{ __typename: 'WorksheetSetSelectItem', id: number, name: string, description: string, gaudiaLevelId: number, order: number, versions: Array<{ __typename: 'WorksheetSetVersionsRelation', id: number, version: number, createdAt: string, worksheetSetVersionItems: Array<{ __typename: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelation', id: number, worksheetVersion?: { __typename: 'WorksheetSetVersionsRelationWorksheetSetVersionItemsRelationWorksheetVersionRelation', id: number, version: number, worksheetId?: number | null } | null }> }> }> };

export type GetWorksheetVersionQueryVariables = Exact<{
  where?: InputMaybe<WorksheetVersionFilters>;
}>;


export type GetWorksheetVersionQuery = { __typename?: 'Query', worksheetVersion: Array<{ __typename?: 'WorksheetVersionSelectItem', id: number, worksheet?: { __typename?: 'WorksheetVersionWorksheetRelation', id: number, name: string, bookOrder: number } | null, worksheetVersionItems: Array<{ __typename?: 'WorksheetVersionWorksheetVersionItemsRelation', id: number, worksheetPageVersionId?: number | null, worksheetVersionId?: number | null, worksheetPageVersion?: { __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelation', id: number, version: number, filename: string, worksheetPage?: { __typename?: 'WorksheetVersionWorksheetVersionItemsRelationWorksheetPageVersionRelationWorksheetPageRelation', id: number, name: string, pageNumber: number } | null } | null }> }> };

export type GetWorksheetVersionDetailQueryVariables = Exact<{
  worksheetId: Scalars['Int']['input'];
  worksheetVersionId: Scalars['Int']['input'];
}>;


export type GetWorksheetVersionDetailQuery = { __typename?: 'Query', getWorksheetVersionDetail?: { __typename: 'WorksheetVersionDetail', id: number, version: number, worksheet?: { __typename: 'WorksheetVersionDetailWorksheetDetail', id: number, name: string, subunit?: { __typename: 'WorksheetVersionDetailSubunit', id: number, name: string } | null, book?: { __typename: 'WorksheetVersionDetailBook', id: number, name: string } | null } | null, pages?: Array<{ __typename: 'WorksheetVersionDetailWorksheetPageDetail', id: number, name: string, pageNumber: number, version: number, versionId: number, filename: string } | null> | null } | null };
